import type { Brand } from "~/tools/brand";
import type { Record } from "~/tools/record";
import { hasProperty } from "~/tools/has-property";

export type JsonRaw = unknown;

export type NodeId = Brand<number, "NodeId">;

export enum Type {

  ArgumentDoubleVal = "ArgumentDoubleVal",
  ArgumentComparatorWithoutEqualityVal = "ArgumentComparatorWithoutEqualityVal",
  ArgumentComponentTypeRef = "ArgumentComponentTypeRef",
  WebSocketStopStream = "WebSocketStopStream",
  CreateMonitors = "CreateMonitors",
  TypeGroup = "TypeGroup",
  NodeLocked = "NodeLocked",
  NodeNotFoundError = "NodeNotFoundError",
  Domain = "Domain",
  OtelInputResource = "OtelInputResource",
  ComponentTypeSource = "ComponentTypeSource",
  LicenseKey = "LicenseKey",
  ContactProperty = "ContactProperty",
  Invalid = "Invalid",
  CreateStackpackConfigurations = "CreateStackpackConfigurations",
  GetApiTokens = "GetApiTokens",
  TopologyEvent = "TopologyEvent",
  NodeUnLocked = "NodeUnLocked",
  ComponentHighlightMetricSection = "ComponentHighlightMetricSection",
  GetOtelMappings = "GetOtelMappings",
  CreateNotifications = "CreateNotifications",
  DetailedServerHealth = "DetailedServerHealth",
  Monitor = "Monitor",
  OtelInputLog = "OtelInputLog",
  DeleteOtelMappings = "DeleteOtelMappings",
  DeleteDashboards = "DeleteDashboards",
  OtelComponentMapping = "OtelComponentMapping",
  LabelPrefixedFilter = "LabelPrefixedFilter",
  ViewTypeTableColContainerImageLink = "ViewTypeTableColContainerImageLink",
  ArgumentFailingHealthStateVal = "ArgumentFailingHealthStateVal",
  LowerIsBetter = "LowerIsBetter",
  ComponentType = "ComponentType",
  ViewTraversalResult = "ViewTraversalResult",
  GetViews = "GetViews",
  HubSpotApiError = "HubSpotApiError",
  OtelVariableMapping = "OtelVariableMapping",
  MetricBindingLayout = "MetricBindingLayout",
  TriggerOnText = "TriggerOnText",
  ComponentTypeRelatedResources = "ComponentTypeRelatedResources",
  ArgumentNodeIdVal = "ArgumentNodeIdVal",
  ExecuteScripts = "ExecuteScripts",
  UpdateStackpacks = "UpdateStackpacks",
  MainMenuViewItem = "MainMenuViewItem",
  ScriptApiRouteError = "ScriptApiRouteError",
  ArgumentStateVal = "ArgumentStateVal",
  UniqueConstraintProtectionError = "UniqueConstraintProtectionError",
  Sync = "Sync",
  RestrictedViewComponent = "RestrictedViewComponent",
  Text = "Text",
  ResourcePermission = "ResourcePermission",
  MonitorDisplayTimeSeries = "MonitorDisplayTimeSeries",
  OtelInputSpan = "OtelInputSpan",
  ArgumentBooleanVal = "ArgumentBooleanVal",
  ServerSuppliedWebUIConfig = "ServerSuppliedWebUIConfig",
  DependSelection = "DependSelection",
  ViewTypeTableColRatio = "ViewTypeTableColRatio",
  GetSettings = "GetSettings",
  ArgumentLongVal = "ArgumentLongVal",
  DurationDisplay = "DurationDisplay",
  HealthCircleDisplay = "HealthCircleDisplay",
  HandlebarsScript = "HandlebarsScript",
  NativeFunctionBody = "NativeFunctionBody",
  InvalidHTTPRequest = "InvalidHttpRequest",
  Remove = "Remove",
  SyncActionCreateOnMerge = "SyncActionCreateOnMerge",
  BooleanTrackingParameter = "BooleanTrackingParameter",
  Synced = "Synced",
  ConstantSource = "ConstantSource",
  DeleteMonitors = "DeleteMonitors",
  RestrictedViewRelation = "RestrictedViewRelation",
  ExecuteRestrictedScripts = "ExecuteRestrictedScripts",
  ExpiredSubscription = "ExpiredSubscription",
  CascadeProtectionError = "CascadeProtectionError",
  DeleteFavoriteViews = "DeleteFavoriteViews",
  IndirectRelation = "IndirectRelation",
  OtelComponentMappingOutput = "OtelComponentMappingOutput",
  ViewTypeTableColComponentType = "ViewTypeTableColComponentType",
  HTTPScriptApiRequest = "HttpScriptApiRequest",
  ViewTimeLink = "ViewTimeLink",
  Subscription = "Subscription",
  ViewTypeTableColNumber = "ViewTypeTableColNumber",
  ViewSnapshotDataUnavailable = "ViewSnapshotDataUnavailable",
  ActionExecutionRequest = "ActionExecutionRequest",
  NameSource = "NameSource",
  SystemPermission = "SystemPermission",
  Step = "Step",
  KeycloakAuthServer = "KeycloakAuthServer",
  SingleNonDeterministicTopologyPath = "SingleNonDeterministicTopologyPath",
  Activities = "Activities",
  MonitorIncompleteHealthState = "MonitorIncompleteHealthState",
  LdapAuthServer = "LdapAuthServer",
  CreateOtelMappings = "CreateOtelMappings",
  SpanFilter = "SpanFilter",
  TraceBinding = "TraceBinding",
  ViewTypeTableColMetricBinding = "ViewTypeTableColMetricBinding",
  TopologyPath = "TopologyPath",
  RelationMappingFunction = "RelationMappingFunction",
  PromQLDisplay = "PromqlDisplay",
  ViewCheck = "ViewCheck",
  SynchronizationData = "SynchronizationData",
  MetricBindingQuery = "MetricBindingQuery",
  ArgumentTimeWindowVal = "ArgumentTimeWindowVal",
  UnlockSettings = "UnlockSettings",
  TopologySyncSettings = "TopologySyncSettings",
  WebUIConfig = "WebUIConfig",
  SubjectWithSource = "SubjectWithSource",
  ScopeDefinition = "ScopeDefinition",
  EventComponent = "EventComponent",
  UnlicensedSubscription = "UnlicensedSubscription",
  ResourceNotFoundError = "ResourceNotFoundError",
  HealthSource = "HealthSource",
  HealthStateData = "HealthStateData",
  QueryViewResponse = "QueryViewResponse",
  TriggerOnParameter = "TriggerOnParameter",
  NodesLockedError = "NodesLockedError",
  GlobalStoreEvent = "GlobalStoreEvent",
  ExtTopoComponent = "ExtTopoComponent",
  StackPackIntegration = "StackPackIntegration",
  InvalidNamespaceExportError = "InvalidNamespaceExportError",
  LightStackPack = "LightStackPack",
  UnknownAuthenticationExceptionError = "UnknownAuthenticationExceptionError",
  WebUIFeatureSwitches = "WebUIFeatureSwitches",
  ExecuteMonitors = "ExecuteMonitors",
  ReadyStatusDisplay = "ReadyStatusDisplay",
  MonitorDisplayQuery = "MonitorDisplayQuery",
  DashboardBackup = "DashboardBackup",
  SyncedCheckState = "SyncedCheckState",
  ApiLimitReached = "ApiLimitReached",
  CreateFavoriteDashboards = "CreateFavoriteDashboards",
  DisplayTimeSeries = "DisplayTimeSeries",
  ViewSnapshotDiff = "ViewSnapshotDiff",
  JsonRaw = "JsonRaw",
  CreatedEvent = "CreatedEvent",
  WebSocketStartStream = "WebSocketStartStream",
  LicensedSubscription = "LicensedSubscription",
  Low = "Low",
  MonitorHealthState = "MonitorHealthState",
  GetAgents = "GetAgents",
  ApiExceptionError = "ApiExceptionError",
  MetricPerspectiveLocation = "MetricPerspectiveLocation",
  StackPackConfiguration = "StackPackConfiguration",
  VersionChangedEvent = "VersionChangedEvent",
  LoginInfo = "LoginInfo",
  CreateServiceTokens = "CreateServiceTokens",
  ViewType = "ViewType",
  HealthSyncSubStreamExpiry = "HealthSyncSubStreamExpiry",
  URLRedirectResponse = "URLRedirectResponse",
  Exporter = "Exporter",
  ScriptFunctionBody = "ScriptFunctionBody",
  GetStackpacks = "GetStackpacks",
  Subject = "Subject",
  DataSource = "DataSource",
  UpdateNotifications = "UpdateNotifications",
  SyncState = "SyncState",
  DisplayQuery = "DisplayQuery",
  ConcurrentProtectionError = "ConcurrentProtectionError",
  StoredMonitor = "StoredMonitor",
  Set = "Set",
  ExtTopoRelation = "ExtTopoRelation",
  TopologyFilters = "TopologyFilters",
  GetSystemNotifications = "GetSystemNotifications",
  GetTraces = "GetTraces",
  StarCount = "StarCount",
  QueryView = "QueryView",
  StringTrackingParameter = "StringTrackingParameter",
  StreamFailed = "StreamFailed",
  ViewSnapshotTooManyActiveQueries = "ViewSnapshotTooManyActiveQueries",
  ServerHealth = "ServerHealth",
  DataUnavailableError = "DataUnavailableError",
  SubjectPermissions = "SubjectPermissions",
  ViewTypeTableColReadyStatus = "ViewTypeTableColReadyStatus",
  ValidationErrors = "ValidationErrors",
  BoundMetricQuery = "BoundMetricQuery",
  TypeGroupClassifier = "TypeGroupClassifier",
  ConfigurationChangedEventType = "ConfigurationChangedEventType",
  FullStackPack = "FullStackPack",
  StqlParserConfig = "StqlParserConfig",
  HTTPScriptApiTextResponse = "HttpScriptApiTextResponse",
  CreateComponentPresentations = "CreateComponentPresentations",
  NamespaceSnapshotError = "NamespaceSnapshotError",
  GetNotifications = "GetNotifications",
  High = "High",
  None = "None",
  SyncActionCreateRelation = "SyncActionCreateRelation",
  InvalidStreamError = "InvalidStreamError",
  ObservabilitySubject = "ObservabilitySubject",
  CreateDashboards = "CreateDashboards",
  TimeSeriesId = "TimeSeriesId",
  PreviewComponent = "PreviewComponent",
  StsTopologyElementsQuery = "StsTopologyElementsQuery",
  IdExtractorFunction = "IdExtractorFunction",
  BoundMetric = "BoundMetric",
  GetServiceTokens = "GetServiceTokens",
  NodesNotUnlockableError = "NodesNotUnlockableError",
  Password = "Password",
  ComponentTypeEvents = "ComponentTypeEvents",
  NumericTrackingParameter = "NumericTrackingParameter",
  ExecuteAi = "ExecuteAi",
  ArgumentStructTypeVal = "ArgumentStructTypeVal",
  MonitorSyncedCheckStateData = "MonitorSyncedCheckStateData",
  TextDisplay = "TextDisplay",
  UpdateComponentPresentations = "UpdateComponentPresentations",
  OtelTagMapping = "OtelTagMapping",
  Dashboard = "Dashboard",
  MetricTimeSeriesResult = "MetricTimeSeriesResult",
  DeletedEvent = "DeletedEvent",
  ShowStmlReport = "ShowStmlReport",
  ComponentTypeExternalComponent = "ComponentTypeExternalComponent",
  DeleteViews = "DeleteViews",
  HealthSyncSubStreamTransactionalIncrements = "HealthSyncSubStreamTransactionalIncrements",
  OtelInput = "OtelInput",
  ComponentPathElement = "ComponentPathElement",
  ViewSnapshotTopologySizeOverflow = "ViewSnapshotTopologySizeOverflow",
  Point = "Point",
  Missing = "Missing",
  MonitorFunction = "MonitorFunction",
  HealthSyncSubStreamSnapshot = "HealthSyncSubStreamSnapshot",
  TagSource = "TagSource",
  UpdateStackpackConfigurations = "UpdateStackpackConfigurations",
  UserProfile = "UserProfile",
  HTTPScriptApiJsonResponse = "HttpScriptApiJsonResponse",
  InternalError = "InternalError",
  RatioDisplay = "RatioDisplay",
  CreateViews = "CreateViews",
  HealthSyncError = "HealthSyncError",
  UpdateDashboards = "UpdateDashboards",
  GetPermissions = "GetPermissions",
  GlobalStoreSnapshot = "GlobalStoreSnapshot",
  WebSocketStreamResponse = "WebSocketStreamResponse",
  ComponentTemplateFunction = "ComponentTemplateFunction",
  ComponentAction = "ComponentAction",
  TagDisplay = "TagDisplay",
  DeleteSyncData = "DeleteSyncData",
  RelationTemplateFunction = "RelationTemplateFunction",
  StackstateAuthServer = "StackstateAuthServer",
  Layer = "Layer",
  UpdateMetrics = "UpdateMetrics",
  HealthTransformerMetaData = "HealthTransformerMetaData",
  HealthBadgeDisplay = "HealthBadgeDisplay",
  GetMetrics = "GetMetrics",
  ExtTopology = "ExtTopology",
  SourceLink = "SourceLink",
  WebSocketClosed = "WebSocketClosed",
  Line = "Line",
  StoredMonitorFunction = "StoredMonitorFunction",
  Anomalies = "Anomalies",
  DetailedHealthState = "DetailedHealthState",
  StackElementState = "StackElementState",
  ViewInfo = "ViewInfo",
  TopologySizeOverflowError = "TopologySizeOverflowError",
  SubjectPermissionsRequest = "SubjectPermissionsRequest",
  GroovyScript = "GroovyScript",
  TimeSeries = "TimeSeries",
  DeleteVersionsResult = "DeleteVersionsResult",
  ArgumentPromQLMetricVal = "ArgumentPromQLMetricVal",
  QueryMetadata = "QueryMetadata",
  StackPackError = "StackPackError",
  BaselinePreviewError = "BaselinePreviewError",
  ApiToken = "ApiToken",
  SpanToComponentBinding = "SpanToComponentBinding",
  UpdateVisualization = "UpdateVisualization",
  GetComponentPresentations = "GetComponentPresentations",
  MonitorMetaData = "MonitorMetaData",
  MainMenuGroup = "MainMenuGroup",
  Others = "Others",
  DeleteStackpacks = "DeleteStackpacks",
  DuplicateIdsError = "DuplicateIdsError",
  QueryStreamRequest = "QueryStreamRequest",
  MetricPerspectiveSection = "MetricPerspectiveSection",
  MultiDisplayTimeSeries = "MultiDisplayTimeSeries",
  UpdateSettings = "UpdateSettings",
  Changes = "Changes",
  OnlineTrialAttributes = "OnlineTrialAttributes",
  ArgumentDurationVal = "ArgumentDurationVal",
  IdentifiersSource = "IdentifiersSource",
  EventRelation = "EventRelation",
  StatusUpdateRequest = "StatusUpdateRequest",
  ViewEventFilters = "ViewEventFilters",
  DeleteFavoriteDashboards = "DeleteFavoriteDashboards",
  ArgumentTopologyQueryVal = "ArgumentTopologyQueryVal",
  ViewTypeTableColComponentLink = "ViewTypeTableColComponentLink",
  ComponentLinkDisplay = "ComponentLinkDisplay",
  QueryParsingFailure = "QueryParsingFailure",
  TopologyScriptApiQuery = "TopologyScriptApiQuery",
  EventStreamMissingDataIssue = "EventStreamMissingDataIssue",
  CreateMetricBindings = "CreateMetricBindings",
  TopologyScriptApiQueryResult = "TopologyScriptApiQueryResult",
  HealthStateChangedEventType = "HealthStateChangedEventType",
  ElementUpdatedEventType = "ElementUpdatedEventType",
  ElementCreatedEventType = "ElementCreatedEventType",
  ViewSnapshotEventsOmitted = "ViewSnapshotEventsOmitted",
  RunStateChangedEventType = "RunStateChangedEventType",
  NullReferenceProtectionError = "NullReferenceProtectionError",
  OtelInputScope = "OtelInputScope",
  OtelInputMetric = "OtelInputMetric",
  HealthSyncSubStream = "HealthSyncSubStream",
  UpdateViews = "UpdateViews",
  MetricBinding = "MetricBinding",
  ActionExecutionTimeContext = "ActionExecutionTimeContext",
  UpdateScopedPermissions = "UpdateScopedPermissions",
  OtelInputDatapoint = "OtelInputDatapoint",
  ViewTypeTableColPromQL = "ViewTypeTableColPromql",
  ViewCheckState = "ViewCheckState",
  TagsSource = "TagsSource",
  GlobalStoreRequest = "GlobalStoreRequest",
  OtelComponentMappingFieldMapping = "OtelComponentMappingFieldMapping",
  RelationType = "RelationType",
  ViewTypeTableColText = "ViewTypeTableColText",
  EventTag = "EventTag",
  PromQLMetric = "PromQLMetric",
  OtelRelationMappingOutput = "OtelRelationMappingOutput",
  ViewSnapshotRequest = "ViewSnapshotRequest",
  Medium = "Medium",
  ComponentTypeField = "ComponentTypeField",
  StsTopologyDataSourceConfig = "StsTopologyDataSourceConfig",
  HealthStateChangedEvent = "HealthStateChangedEvent",
  KeepAlive = "KeepAlive",
  Increment = "Increment",
  ElasticSearchAccessError = "ElasticSearchAccessError",
  ComponentTypeMetricCategory = "ComponentTypeMetricCategory",
  ComponentTypeLabel = "ComponentTypeLabel",
  ScriptApiComponent = "ScriptApiComponent",
  LastUpdatedTimestampSource = "LastUpdatedTimestampSource",
  ViewComponent = "ViewComponent",
  Parameter = "Parameter",
  ViewTypeTableColDuration = "ViewTypeTableColDuration",
  Label = "Label",
  DeleteComponentPresentations = "DeleteComponentPresentations",
  DeleteMetricBindings = "DeleteMetricBindings",
  OtelRelationMapping = "OtelRelationMapping",
  ServiceToken = "ServiceToken",
  GroupRelation = "GroupRelation",
  Contact = "Contact",
  BoundMetrics = "BoundMetrics",
  TopologyPromQLMetric = "TopologyPromQLMetric",
  FAQ = "FAQ",
  ComponentTypeAbout = "ComponentTypeAbout",
  DeleteStackpackConfigurations = "DeleteStackpackConfigurations",
  Relation = "Relation",
  MonitorCompletesAsynchronously = "MonitorCompletesAsynchronously",
  ComponentSummaryLocation = "ComponentSummaryLocation",
  ArgumentRelationTypeRef = "ArgumentRelationTypeRef",
  NodesUnlockedError = "NodesUnlockedError",
  ListTrackingParameter = "ListTrackingParameter",
  SubjectPermissionsResponse = "SubjectPermissionsResponse",
  StackPackVersionInfo = "StackPackVersionInfo",
  StackPackStateChangeEvent = "StackPackStateChangeEvent",
  UpdatePermissions = "UpdatePermissions",
  UpdateMonitors = "UpdateMonitors",
  PropertySource = "PropertySource",
  ViewSnapshotFetchTimeout = "ViewSnapshotFetchTimeout",
  TrackingError = "TrackingError",
  ResolveError = "ResolveError",
  ArgumentStringVal = "ArgumentStringVal",
  InvalidPropertyValue = "InvalidPropertyValue",
  ArgumentQueryViewRef = "ArgumentQueryViewRef",
  PropertyDoesNotExist = "PropertyDoesNotExist",
  ViewSnapshot = "ViewSnapshot",
  CreateFavoriteViews = "CreateFavoriteViews",
  ComponentActionDefinition = "ComponentActionDefinition",
  Alerts = "Alerts",
  ElementDeletedEventType = "ElementDeletedEventType",
  StoredExternalMonitor = "StoredExternalMonitor",
  UpdateOtelMappings = "UpdateOtelMappings",
  InvalidTimetravelMoment = "InvalidTimetravelMoment",
  ExecutableComponentAction = "ExecutableComponentAction",
  HigherIsBetter = "HigherIsBetter",
  GetMetricBindings = "GetMetricBindings",
  EmbeddingParentUpdatedEvent = "EmbeddingParentUpdatedEvent",
  VisualizerSettings = "VisualizerSettings",
  InternalServerError = "InternalServerError",
  PromQLInstantMetricQuery = "PromqlInstantMetricQuery",
  VersionChangedEventType = "VersionChangedEventType",
  NodeId = "NodeId",
  MetricPerspectiveTab = "MetricPerspectiveTab",
  MetricStreamAnomalyEventType = "MetricStreamAnomalyEventType",
  HealthSyncStream = "HealthSyncStream",
  ShowTopologyByQuery = "ShowTopologyByQuery",
  QuerySnapshotResult = "QuerySnapshotResult",
  ViewSnapshotMetadata = "ViewSnapshotMetadata",
  TopologyPathExistsDeeperThan = "TopologyPathExistsDeeperThan",
  ExternalMonitor = "ExternalMonitor",
  Component = "Component",
  DeleteNotifications = "DeleteNotifications",
  Deployments = "Deployments",
  ViewSnapshotEventsSucceeded = "ViewSnapshotEventsSucceeded",
  UpdateMetricBindings = "UpdateMetricBindings",
  ViewSnapshotEventsFetchError = "ViewSnapshotEventsFetchError",
  TriggerOnTemplate = "TriggerOnTemplate",
  GetTopicMessages = "GetTopicMessages",
  TopologyScopeError = "TopologyScopeError",
  ViewTypeTableColName = "ViewTypeTableColName",
  GetMonitors = "GetMonitors",
  ComponentTypeHighlights = "ComponentTypeHighlights",
  TimestampTrackingParameter = "TimestampTrackingParameter",
  GetDashboards = "GetDashboards",
  ArgumentTopologyPromQLMetricVal = "ArgumentTopologyPromQLMetricVal",
  ErrorsResponse = "ErrorsResponse",
  ExecuteComponentActions = "ExecuteComponentActions",
  TopologyScriptApiQueryResponse = "TopologyScriptApiQueryResponse",
  DeleteServiceTokens = "DeleteServiceTokens",
  GetSyncData = "GetSyncData",
  ViewTypeOverview = "ViewTypeOverview",
  TemplateExecutionRequest = "TemplateExecutionRequest",
  RelationPathElement = "RelationPathElement",
  SetTrackingParameter = "SetTrackingParameter",
  SyncActionCreateComponent = "SyncActionCreateComponent",
  ServerTimeoutError = "ServerTimeoutError",
  ViewTypeTableColHealth = "ViewTypeTableColHealth",
  UpdatedEvent = "UpdatedEvent",
  ComponentMappingFunction = "ComponentMappingFunction",
  SubscriptionError = "SubscriptionError",
  StackPackResourceConfig = "StackPackResourceConfig",
  GetTopology = "GetTopology",
  OidcAuthServer = "OidcAuthServer",
  PromQLMetricQuery = "PromqlMetricQuery",
  ViewTypeTableColTime = "ViewTypeTableColTime",
  ComponentHighlightLocation = "ComponentHighlightLocation",
  ViewRelation = "ViewRelation",
  CompositeSource = "CompositeSource",
  Append = "Append",
  TopologyScriptApiQueryDiff = "TopologyScriptApiQueryDiff",
  TrackingSuccess = "TrackingSuccess",
}

const isType = <TEntry extends {_type: string}>(type: TEntry["_type"]) => (input: unknown): input is TEntry => {
  return hasProperty(input, "_type") && input._type === type;
};


export interface OtelComponentMappingFieldMapping {
  _type: Type.OtelComponentMappingFieldMapping;
  additionalIdentifiers?: Array<string>;
  version?: string;
  tags?: Array<OtelTagMapping>;
  configuration?: string;
  status?: string;
}

export const isOtelComponentMappingFieldMapping = isType<OtelComponentMappingFieldMapping>(Type.OtelComponentMappingFieldMapping);


export interface OtelComponentMappingOutput {
  _type: Type.OtelComponentMappingOutput;
  identifier: string;
  name: string;
  typeName: string;
  typeIdentifier?: string;
  layerName: string;
  layerIdentifier?: string;
  domainName: string;
  domainIdentifier?: string;
  required?: OtelComponentMappingFieldMapping;
  optional?: OtelComponentMappingFieldMapping;
}

export const isOtelComponentMappingOutput = isType<OtelComponentMappingOutput>(Type.OtelComponentMappingOutput);


export interface OtelInput {
  _type: Type.OtelInput;
  signal: Array<OtelInputSignal>;
  resource: OtelInputResource;
}

export const isOtelInput = isType<OtelInput>(Type.OtelInput);


export interface OtelInputDatapoint {
  _type: Type.OtelInputDatapoint;
  condition?: string;
  action?: string;
}

export const isOtelInputDatapoint = isType<OtelInputDatapoint>(Type.OtelInputDatapoint);


export interface OtelInputLog {
  _type: Type.OtelInputLog;
  condition?: string;
  action?: string;
}

export const isOtelInputLog = isType<OtelInputLog>(Type.OtelInputLog);


export interface OtelInputMetric {
  _type: Type.OtelInputMetric;
  condition?: string;
  action?: string;
  datapoint?: OtelInputDatapoint;
}

export const isOtelInputMetric = isType<OtelInputMetric>(Type.OtelInputMetric);


export interface OtelInputResource {
  _type: Type.OtelInputResource;
  condition?: string;
  action?: string;
  scope?: OtelInputScope;
}

export const isOtelInputResource = isType<OtelInputResource>(Type.OtelInputResource);


export interface OtelInputScope {
  _type: Type.OtelInputScope;
  condition?: string;
  action?: string;
  metric?: OtelInputMetric;
  span?: OtelInputSpan;
  log?: OtelInputLog;
}

export const isOtelInputScope = isType<OtelInputScope>(Type.OtelInputScope);

export enum OtelInputSignal {
  Traces = "TRACES",
  Metrics = "METRICS",
  Logs = "LOGS",
}


export interface OtelInputSpan {
  _type: Type.OtelInputSpan;
  condition?: string;
  action?: string;
}

export const isOtelInputSpan = isType<OtelInputSpan>(Type.OtelInputSpan);


export interface OtelRelationMappingOutput {
  _type: Type.OtelRelationMappingOutput;
  sourceId: string;
  targetId: string;
  typeName: string;
  typeIdentifier?: string;
}

export const isOtelRelationMappingOutput = isType<OtelRelationMappingOutput>(Type.OtelRelationMappingOutput);


export interface OtelTagMapping {
  _type: Type.OtelTagMapping;
  source: string;
  target: string;
  pattern?: string;
}

export const isOtelTagMapping = isType<OtelTagMapping>(Type.OtelTagMapping);


export interface OtelVariableMapping {
  _type: Type.OtelVariableMapping;
  name: string;
  value: string;
}

export const isOtelVariableMapping = isType<OtelVariableMapping>(Type.OtelVariableMapping);

export enum ApplicationDomain {
  Observability = "Observability",
  Security = "Security",
}

export enum DeploymentMode {
  Saas = "Saas",
  SelfHosted = "SelfHosted",
  MultiTenant = "MultiTenant",
}

export enum Edition {
  Community = "Community",
  Prime = "Prime",
}


export interface StqlParserConfig {
  _type: Type.StqlParserConfig;
  maxLevels: number;
}

export const isStqlParserConfig = isType<StqlParserConfig>(Type.StqlParserConfig);

export enum SupportMode {
  ContactStackstate = "ContactStackstate",
  Documentation = "Documentation",
}


export interface VisualizerSettings {
  _type: Type.VisualizerSettings;
  reduceCrossingsSweeps: number;
  foreignWeightMultiplier: number;
  vertexWidth: number;
  betweenDummyNodeWidth: number;
  compactionMaxPlaceBlockDepth: number;
  compactionMaxLinkedListIterations: number;
  groupRatioX: number;
  groupRatioY: number;
}

export const isVisualizerSettings = isType<VisualizerSettings>(Type.VisualizerSettings);


export interface WebUIConfig {
  _type: Type.WebUIConfig;
  defaultAjaxRequestTimeout: number;
  metricSelectionLimit: number;
  streamAddLimit: number;
  streamReconnectTimeout: number;
  eventStreamMostRecentCountLimit: number;
  logStreamMostRecentLimit: number;
  detailedNodesOnCascadeDeleteLimit: number;
  streamConnectionStatusChangeDelay: number;
  searchResultLimit: number;
  eventsCheckPollingTimeout: number;
  maxRenderableVisualElements: number;
  exportModelTimeout: number;
  importModelTimeout: number;
  visualizer: VisualizerSettings;
  featureFlags: WebUIFeatureSwitches;
  docLinkUrlPrefix: string;
  supportMode: SupportMode;
  defaultTimeRange: string;
}

export const isWebUIConfig = isType<WebUIConfig>(Type.WebUIConfig);


export interface WebUIFeatureSwitches {
  _type: Type.WebUIFeatureSwitches;
  eventSummaryUpdateInterval: number;
  disabledPlugins: Array<string>;
  showWelcomePage: boolean;
  trackingHotJar: boolean;
  onlineTrial: boolean;
  visibleStackPacks?: Array<string>;
  trackingPendo: boolean;
  playground: boolean;
  trackingGoogleAnalytics: boolean;
  trackingHubSpot: boolean;
  newMetrics: boolean;
  traces: boolean;
  dashboards: boolean;
}

export const isWebUIFeatureSwitches = isType<WebUIFeatureSwitches>(Type.WebUIFeatureSwitches);

export enum OnlyForEdition {
  Community = "Community",
  Prime = "Prime",
}

export enum DashboardScope {
  Private = "Private",
  Public = "Public",
}

export enum NativeFunctionBodyId {
  TransparentPropagation = "TRANSPARENT_PROPAGATION",
  AutoPropagation = "AUTO_PROPAGATION",
  ThresholdMonitor = "THRESHOLD_MONITOR",
  TopologyHealthAggregatorMonitor = "TOPOLOGY_HEALTH_AGGREGATOR_MONITOR",
  TopologyHealthAggregatorMonitorV2 = "TOPOLOGY_HEALTH_AGGREGATOR_MONITOR_V2",
  OrphanMonitor = "ORPHAN_MONITOR",
  TopologyTimestampExpirationMonitor = "TOPOLOGY_TIMESTAMP_EXPIRATION_MONITOR",
  TopologicalThresholdMonitor = "TOPOLOGICAL_THRESHOLD_MONITOR",
  DefaultIdExtractorFunction = "DEFAULT_ID_EXTRACTOR_FUNCTION",
  K8sComponentIdExtractorFunction = "K8S_COMPONENT_ID_EXTRACTOR_FUNCTION",
  K8sRelationIdExtractorFunction = "K8S_RELATION_ID_EXTRACTOR_FUNCTION",
  AgentComponentIdExtractorFunction = "AGENT_COMPONENT_ID_EXTRACTOR_FUNCTION",
  DerivedStateMonitor = "DERIVED_STATE_MONITOR",
}

export enum ParameterType {
  Boolean = "BOOLEAN",
  Long = "LONG",
  NodeId = "NODE_ID",
  Double = "DOUBLE",
  String = "STRING",
  MetricStream = "METRIC_STREAM",
  BaselineMetricStream = "BASELINE_METRIC_STREAM",
  MetricStreamId = "METRIC_STREAM_ID",
  EventStream = "EVENT_STREAM",
  ComponentType = "COMPONENT_TYPE",
  RelationType = "RELATION_TYPE",
  StsEventStream = "STS_EVENT_STREAM",
  ExtTopologyComponent = "EXT_TOPOLOGY_COMPONENT",
  ExtTopologyRelation = "EXT_TOPOLOGY_RELATION",
  StateValue = "STATE_VALUE",
  RunStateValue = "RUN_STATE_VALUE",
  StructType = "STRUCT_TYPE",
  Duration = "DURATION",
  SimpleTrainingPeriodicity = "SIMPLE_TRAINING_PERIODICITY",
  Component = "COMPONENT",
  PropagatedHealthStateValue = "PROPAGATED_HEALTH_STATE_VALUE",
  AnomalyDirection = "ANOMALY_DIRECTION",
  ScriptMetricQuery = "SCRIPT_METRIC_QUERY",
  Dto = "DTO",
  QueryView = "QUERY_VIEW",
  TimeWindow = "TIME_WINDOW",
  FailingHealthState = "FAILING_HEALTH_STATE",
  PromQLMetric = "PROMQL_METRIC",
  ComparatorWithoutEquality = "COMPARATOR_WITHOUT_EQUALITY",
  GroupByTopologyComponent = "GROUP_BY_TOPOLOGY_COMPONENT",
  TopologyQuery = "TOPOLOGY_QUERY",
  TopologyPromQLMetric = "TOPOLOGY_PROMQL_METRIC",
}

export enum ComparatorWithoutEquality {
  GTE = "GTE",
  GT = "GT",
  LTE = "LTE",
  LT = "LT",
}

export enum MonitorStatusValue {
  Enabled = "ENABLED",
  Disabled = "DISABLED",
}

export enum PermissionValue {
  CreateViews = "CREATE_VIEWS",
  AccessAnalytics = "ACCESS_ANALYTICS",
  ExecuteScripts = "EXECUTE_SCRIPTS",
  ExecuteRestrictedScripts = "EXECUTE_RESTRICTED_SCRIPTS",
  ReadSettings = "READ_SETTINGS",
  UpdateSettings = "UPDATE_SETTINGS",
  ImportSettings = "IMPORT_SETTINGS",
  ExportSettings = "EXPORT_SETTINGS",
  ManageTopologyElements = "MANAGE_TOPOLOGY_ELEMENTS",
  AccessTopologyElementsHealth = "ACCESS_TOPOLOGY_ELEMENTS_HEALTH",
  AccessCLI = "ACCESS_CLI",
  AccessExplore = "ACCESS_EXPLORE",
  UpdateVisualization = "UPDATE_VISUALIZATION",
  ReadPermissions = "READ_PERMISSIONS",
  UpdatePermissions = "UPDATE_PERMISSIONS",
  UpdateScopedPermissions = "UPDATE_SCOPED_PERMISSIONS",
  ManageServiceTokens = "MANAGE_SERVICE_TOKENS",
  GetServiceTokens = "GET_SERVICE_TOKENS",
  CreateServiceTokens = "CREATE_SERVICE_TOKENS",
  DeleteServiceTokens = "DELETE_SERVICE_TOKENS",
  ManageIngestionApiKeys = "MANAGE_INGESTION_API_KEYS",
  GetIngestionApiKeys = "GET_INGESTION_API_KEYS",
  CreateIngestionApiKeys = "CREATE_INGESTION_API_KEYS",
  DeleteIngestionApiKeys = "DELETE_INGESTION_API_KEYS",
  CreateTelemetry = "CREATE_TELEMETRY",
  ReadStackpacks = "READ_STACKPACKS",
  ManageStackpacks = "MANAGE_STACKPACKS",
  CreateStackpackConfigurations = "CREATE_STACKPACK_CONFIGURATIONS",
  UpdateStackpackConfigurations = "UPDATE_STACKPACK_CONFIGURATIONS",
  DeleteStackpackConfigurations = "DELETE_STACKPACK_CONFIGURATIONS",
  PerformCustomQuery = "PERFORM_CUSTOM_QUERY",
  ExecuteComponentTemplates = "EXECUTE_COMPONENT_TEMPLATES",
  AccessTopicData = "ACCESS_TOPIC_DATA",
  AccessLogData = "ACCESS_LOG_DATA",
  AccessSynchronizationData = "ACCESS_SYNCHRONIZATION_DATA",
  ExecuteNodeSync = "EXECUTE_NODE_SYNC",
  DeleteSyncData = "DELETE_SYNC_DATA",
  AccessAdminApi = "ACCESS_ADMIN_API",
  SaveView = "SAVE_VIEW",
  AccessView = "ACCESS_VIEW",
  ManageStarView = "MANAGE_STAR_VIEW",
  CreateFavoriteViews = "CREATE_FAVORITE_VIEWS",
  DeleteFavoriteViews = "DELETE_FAVORITE_VIEWS",
  AccessViewHealth = "ACCESS_VIEW_HEALTH",
  DeleteView = "DELETE_VIEW",
  AccessTelemetryStreams = "ACCESS_TELEMETRY_STREAMS",
  ManageTelemetryStreams = "MANAGE_TELEMETRY_STREAMS",
  ExecuteComponentActions = "EXECUTE_COMPONENT_ACTIONS",
  AccessProblemsData = "ACCESS_PROBLEMS_DATA",
  ManageAnnotations = "MANAGE_ANNOTATIONS",
  ManageEventHandlers = "MANAGE_EVENT_HANDLERS",
  UploadStackpacks = "UPLOAD_STACKPACKS",
  ManageMonitors = "MANAGE_MONITORS",
  RunMonitors = "RUN_MONITORS",
  ViewMonitors = "VIEW_MONITORS",
  CreateMonitors = "CREATE_MONITORS",
  UpdateMonitors = "UPDATE_MONITORS",
  DeleteMonitors = "DELETE_MONITORS",
  ReadMetrics = "READ_METRICS",
  ReadTelemetryStreams = "READ_TELEMETRY_STREAMS",
  ManageNotifications = "MANAGE_NOTIFICATIONS",
  ViewNotifications = "VIEW_NOTIFICATIONS",
  CreateNotifications = "CREATE_NOTIFICATIONS",
  UpdateNotifications = "UPDATE_NOTIFICATIONS",
  DeleteNotifications = "DELETE_NOTIFICATIONS",
  ManageMetricBindings = "MANAGE_METRIC_BINDINGS",
  ViewMetricBindings = "VIEW_METRIC_BINDINGS",
  CreateMetricBindings = "CREATE_METRIC_BINDINGS",
  UpdateMetricBindings = "UPDATE_METRIC_BINDINGS",
  DeleteMetricBindings = "DELETE_METRIC_BINDINGS",
  UnlockNode = "UNLOCK_NODE",
  ReadTraces = "READ_TRACES",
  ReadAgents = "READ_AGENTS",
  ReadSystemNotifications = "READ_SYSTEM_NOTIFICATIONS",
  ViewDashboards = "VIEW_DASHBOARDS",
  CreateDashboards = "CREATE_DASHBOARDS",
  UpdateDashboards = "UPDATE_DASHBOARDS",
  DeleteDashboards = "DELETE_DASHBOARDS",
  CreateFavoriteDashboards = "CREATE_FAVORITE_DASHBOARDS",
  DeleteFavoriteDashboards = "DELETE_FAVORITE_DASHBOARDS",
  GetAgents = "GET_AGENTS",
  GetApiTokens = "GET_API_TOKENS",
  GetMetricBindings = "GET_METRIC_BINDINGS",
  GetMetrics = "GET_METRICS",
  GetTraces = "GET_TRACES",
  UpdateMetrics = "UPDATE_METRICS",
  GetMonitors = "GET_MONITORS",
  ExecuteMonitors = "EXECUTE_MONITORS",
  GetNotifications = "GET_NOTIFICATIONS",
  GetPermissions = "GET_PERMISSIONS",
  GetSettings = "GET_SETTINGS",
  UnlockSettings = "UNLOCK_SETTINGS",
  GetStackpacks = "GET_STACKPACKS",
  UpdateStackpacks = "UPDATE_STACKPACKS",
  DeleteStackpacks = "DELETE_STACKPACKS",
  GetSyncData = "GET_SYNC_DATA",
  GetSystemNotifications = "GET_SYSTEM_NOTIFICATIONS",
  GetTopicMessages = "GET_TOPIC_MESSAGES",
  GetTopology = "GET_TOPOLOGY",
  GetViews = "GET_VIEWS",
  UpdateViews = "UPDATE_VIEWS",
  DeleteViews = "DELETE_VIEWS",
  GetDashboards = "GET_DASHBOARDS",
  GetComponentPresentatons = "GET_COMPONENT_PRESENTATONS",
  CreateComponentPresentatons = "CREATE_COMPONENT_PRESENTATONS",
  UpdateComponentPresentatons = "UPDATE_COMPONENT_PRESENTATONS",
  DeleteComponentPresentatons = "DELETE_COMPONENT_PRESENTATONS",
  GetOtelMappings = "GET_OTEL_MAPPINGS",
  CreateOtelMappings = "CREATE_OTEL_MAPPINGS",
  UpdateOtelMappings = "UPDATE_OTEL_MAPPINGS",
  DeleteOtelMappings = "DELETE_OTEL_MAPPINGS",
  ExecuteAi = "EXECUTE_AI",
}

export enum DependencyDirection {
  OneWay = "ONE_WAY",
  None = "NONE",
  Both = "BOTH",
}

export enum DependencyType {
  Unclassified = "UNCLASSIFIED",
  Runtime = "RUNTIME",
  Batch = "BATCH",
  Startup = "STARTUP",
  Hierarchical = "HIERARCHICAL",
  Connection = "CONNECTION",
}

export enum RunMode {
  Normal = "NORMAL",
  Empty = "EMPTY",
  Dev = "DEV",
}

export enum HealthSyncErrorState {
  Unknown = "UNKNOWN",
  StaleDataStream = "STALE_DATA_STREAM",
}

export enum FailingHealthStateValue {
  Deviating = "DEVIATING",
  Critical = "CRITICAL",
  Unknown = "UNKNOWN",
}

export enum HealthStateValue {
  Uninitialized = "UNINITIALIZED",
  Unknown = "UNKNOWN",
  Clear = "CLEAR",
  Disabled = "DISABLED",
  Deviating = "DEVIATING",
  Flapping = "FLAPPING",
  Critical = "CRITICAL",
}

export enum MergeStrategy {
  UseMine = "UseMine",
  MergePreferMine = "MergePreferMine",
  MergePreferTheirs = "MergePreferTheirs",
  UseTheirs = "UseTheirs",
}

export enum SpanKind {
  Client = "Client",
  Consumer = "Consumer",
  Internal = "Internal",
  Producer = "Producer",
  Server = "Server",
  Unspecified = "Unspecified",
}

export enum SpanParentType {
  External = "External",
  Internal = "Internal",
  Root = "Root",
}

export enum SpanStatusCode {
  Error = "Error",
  Ok = "Ok",
  Unset = "Unset",
}

export enum ViewFlagValue {
  NotUnlockable = "NotUnlockable",
  HideFromViewsOverview = "HideFromViewsOverview",
  DisableEventHandlers = "DisableEventHandlers",
}

export enum TopologyFilterValue {
  Topology = "TOPOLOGY",
  Events = "EVENTS",
  Traces = "TRACES",
}

export enum ViewTypeFlagValue {
  NoTopologyFilters = "NoTopologyFilters",
  CardsLayout = "CardsLayout",
}


export type Dto = AbstractDisplayTimeSeries | ActionExecutionRequest | ActionExecutionTimeContext | Activities | Alerts | Anomalies | ApiError | Append | BoundMetric | BoundMetrics | Changes | ComponentAction | ComponentTypeAbout | ComponentTypeExternalComponent | ComponentTypeField | ComponentTypeFieldDisplay | ComponentTypeHighlights | ComponentTypeLabel | ComponentTypeMetricCategory | ComponentTypeRelatedResources | ComponentTypeValueExtractor | ConfigurationChangedEventType | Contact | ContactProperty | CreateComponentPresentations | CreateDashboards | CreateFavoriteDashboards | CreateFavoriteViews | CreateMetricBindings | CreateMonitors | CreateNotifications | CreateOtelMappings | CreateServiceTokens | CreateStackpackConfigurations | CreateViews | DeleteComponentPresentations | DeleteDashboards | DeleteFavoriteDashboards | DeleteFavoriteViews | DeleteMetricBindings | DeleteMonitors | DeleteNotifications | DeleteOtelMappings | DeleteServiceTokens | DeleteStackpackConfigurations | DeleteStackpacks | DeleteSyncData | DeleteVersionsResult | DeleteViews | DependSelection | Deployments | DetailedHealthState | DetailedServerHealth | DisplayQuery | ElementCreatedEventType | ElementDeletedEventType | ElementUpdatedEventType | ErrorsResponse | Event | EventElement | EventTag | ExecuteAi | ExecuteComponentActions | ExecuteMonitors | ExecuteRestrictedScripts | ExecuteScripts | Exporter | FAQ | FunctionBody | GetAgents | GetApiTokens | GetComponentPresentations | GetDashboards | GetMetricBindings | GetMetrics | GetMonitors | GetNotifications | GetOtelMappings | GetPermissions | GetServiceTokens | GetSettings | GetStackpacks | GetSyncData | GetSystemNotifications | GetTopicMessages | GetTopology | GetTraces | GetViews | GlobalStoreEvent | GlobalStoreSnapshot | GroupRelation | HTTPScriptApiRequest | HTTPScriptApiResponse | HealthStateChangedEventType | HealthStateData | HealthSyncError | HealthSyncStream | HealthSyncStreamMetaData | HealthSyncSubStream | HealthSyncSubStreamConsistencyState | High | HigherIsBetter | HubSpotError | Increment | IndirectRelation | Invalid | KeepAlive | KeycloakAuthServer | LdapAuthServer | LicenseKey | Line | LockedResponse | LoginInfo | Low | LowerIsBetter | MainMenuViewItem | Medium | MetricStreamAnomalyEventType | MetricTimeSeriesResult | Missing | MonitorDisplayQuery | MonitorDisplayTimeSeries | MonitorResult | Node | None | OidcAuthServer | OnlineTrialAttributes | Others | Point | PreviewComponent | PromQLInstantMetricQuery | PromQLMetricQuery | QueryMetadata | QuerySnapshotResponse | QueryViewResponse | Remove | RunStateChangedEventType | ScopeDefinition | ScriptApiComponent | ServerHealth | ServerSuppliedWebUIConfig | Set | SocketStreamRequest | SourceLink | SpanFilter | StackElementState | StackPack | StackPackIntegration | StackPackResourceConfig | StackPackVersionInfo | StackstateAuthServer | Step | StepType | StoredNode | StqlParserConfig | Subject | SubjectPermissions | SubjectPermissionsResponse | SubjectWithSource | Subscription | SubscriptionState | SyncState | SyncedCheckState | SynchronizationData | TemplateExecutionRequest | TimeSeries | TimeSeriesId | TopologyEvent | TopologyPath | TopologyPathElement | TopologyPaths | TopologyScriptApiQuery | TopologyScriptApiQueryDiff | TopologyScriptApiQueryResponse | TopologyScriptApiQueryResult | TrackingParameter | TrackingResponse | TriggerOnPart | TriggerOnTemplate | TypeGroup | TypeGroupClassifier | UIAction | UnlockSettings | UpdateComponentPresentations | UpdateDashboards | UpdateMetricBindings | UpdateMetrics | UpdateMonitors | UpdateNotifications | UpdateOtelMappings | UpdatePermissions | UpdateScopedPermissions | UpdateSettings | UpdateStackpackConfigurations | UpdateStackpacks | UpdateViews | UpdateVisualization | UserScript | VersionChangedEventType | ViewCheck | ViewCheckState | ViewEventFilters | ViewInfo | ViewSnapshotEventsResponseStatus | ViewSnapshotMetadata | ViewSnapshotRequest | ViewSnapshotResponse | ViewSnapshotStreamResponse | ViewTypeFilter | ViewTypeOverview | ViewTypeTableCol | VisualizerSettings | WebSocketInProtocol | WebSocketOutProtocol | WebUIConfig | WebUIFeatureSwitches;

export function isDto(input: unknown): input is Dto {
  return isAbstractDisplayTimeSeries(input) || isActionExecutionRequest(input) || isActionExecutionTimeContext(input) || isActivities(input) || isAlerts(input) || isAnomalies(input) || isApiError(input) || isAppend(input) || isBoundMetric(input) || isBoundMetrics(input) || isChanges(input) || isComponentAction(input) || isComponentTypeAbout(input) || isComponentTypeExternalComponent(input) || isComponentTypeField(input) || isComponentTypeFieldDisplay(input) || isComponentTypeHighlights(input) || isComponentTypeLabel(input) || isComponentTypeMetricCategory(input) || isComponentTypeRelatedResources(input) || isComponentTypeValueExtractor(input) || isConfigurationChangedEventType(input) || isContact(input) || isContactProperty(input) || isCreateComponentPresentations(input) || isCreateDashboards(input) || isCreateFavoriteDashboards(input) || isCreateFavoriteViews(input) || isCreateMetricBindings(input) || isCreateMonitors(input) || isCreateNotifications(input) || isCreateOtelMappings(input) || isCreateServiceTokens(input) || isCreateStackpackConfigurations(input) || isCreateViews(input) || isDeleteComponentPresentations(input) || isDeleteDashboards(input) || isDeleteFavoriteDashboards(input) || isDeleteFavoriteViews(input) || isDeleteMetricBindings(input) || isDeleteMonitors(input) || isDeleteNotifications(input) || isDeleteOtelMappings(input) || isDeleteServiceTokens(input) || isDeleteStackpackConfigurations(input) || isDeleteStackpacks(input) || isDeleteSyncData(input) || isDeleteVersionsResult(input) || isDeleteViews(input) || isDependSelection(input) || isDeployments(input) || isDetailedHealthState(input) || isDetailedServerHealth(input) || isDisplayQuery(input) || isElementCreatedEventType(input) || isElementDeletedEventType(input) || isElementUpdatedEventType(input) || isErrorsResponse(input) || isEvent(input) || isEventElement(input) || isEventTag(input) || isExecuteAi(input) || isExecuteComponentActions(input) || isExecuteMonitors(input) || isExecuteRestrictedScripts(input) || isExecuteScripts(input) || isExporter(input) || isFAQ(input) || isFunctionBody(input) || isGetAgents(input) || isGetApiTokens(input) || isGetComponentPresentations(input) || isGetDashboards(input) || isGetMetricBindings(input) || isGetMetrics(input) || isGetMonitors(input) || isGetNotifications(input) || isGetOtelMappings(input) || isGetPermissions(input) || isGetServiceTokens(input) || isGetSettings(input) || isGetStackpacks(input) || isGetSyncData(input) || isGetSystemNotifications(input) || isGetTopicMessages(input) || isGetTopology(input) || isGetTraces(input) || isGetViews(input) || isGlobalStoreEvent(input) || isGlobalStoreSnapshot(input) || isGroupRelation(input) || isHTTPScriptApiRequest(input) || isHTTPScriptApiResponse(input) || isHealthStateChangedEventType(input) || isHealthStateData(input) || isHealthSyncError(input) || isHealthSyncStream(input) || isHealthSyncStreamMetaData(input) || isHealthSyncSubStream(input) || isHealthSyncSubStreamConsistencyState(input) || isHigh(input) || isHigherIsBetter(input) || isHubSpotError(input) || isIncrement(input) || isIndirectRelation(input) || isInvalid(input) || isKeepAlive(input) || isKeycloakAuthServer(input) || isLdapAuthServer(input) || isLicenseKey(input) || isLine(input) || isLockedResponse(input) || isLoginInfo(input) || isLow(input) || isLowerIsBetter(input) || isMainMenuViewItem(input) || isMedium(input) || isMetricStreamAnomalyEventType(input) || isMetricTimeSeriesResult(input) || isMissing(input) || isMonitorDisplayQuery(input) || isMonitorDisplayTimeSeries(input) || isMonitorResult(input) || isNode(input) || isNone(input) || isOidcAuthServer(input) || isOnlineTrialAttributes(input) || isOthers(input) || isPoint(input) || isPreviewComponent(input) || isPromQLInstantMetricQuery(input) || isPromQLMetricQuery(input) || isQueryMetadata(input) || isQuerySnapshotResponse(input) || isQueryViewResponse(input) || isRemove(input) || isRunStateChangedEventType(input) || isScopeDefinition(input) || isScriptApiComponent(input) || isServerHealth(input) || isServerSuppliedWebUIConfig(input) || isSet(input) || isSocketStreamRequest(input) || isSourceLink(input) || isSpanFilter(input) || isStackElementState(input) || isStackPack(input) || isStackPackIntegration(input) || isStackPackResourceConfig(input) || isStackPackVersionInfo(input) || isStackstateAuthServer(input) || isStep(input) || isStepType(input) || isStoredNode(input) || isStqlParserConfig(input) || isSubject(input) || isSubjectPermissions(input) || isSubjectPermissionsResponse(input) || isSubjectWithSource(input) || isSubscription(input) || isSubscriptionState(input) || isSyncState(input) || isSyncedCheckState(input) || isSynchronizationData(input) || isTemplateExecutionRequest(input) || isTimeSeries(input) || isTimeSeriesId(input) || isTopologyEvent(input) || isTopologyPath(input) || isTopologyPathElement(input) || isTopologyPaths(input) || isTopologyScriptApiQuery(input) || isTopologyScriptApiQueryDiff(input) || isTopologyScriptApiQueryResponse(input) || isTopologyScriptApiQueryResult(input) || isTrackingParameter(input) || isTrackingResponse(input) || isTriggerOnPart(input) || isTriggerOnTemplate(input) || isTypeGroup(input) || isTypeGroupClassifier(input) || isUIAction(input) || isUnlockSettings(input) || isUpdateComponentPresentations(input) || isUpdateDashboards(input) || isUpdateMetricBindings(input) || isUpdateMetrics(input) || isUpdateMonitors(input) || isUpdateNotifications(input) || isUpdateOtelMappings(input) || isUpdatePermissions(input) || isUpdateScopedPermissions(input) || isUpdateSettings(input) || isUpdateStackpackConfigurations(input) || isUpdateStackpacks(input) || isUpdateViews(input) || isUpdateVisualization(input) || isUserScript(input) || isVersionChangedEventType(input) || isViewCheck(input) || isViewCheckState(input) || isViewEventFilters(input) || isViewInfo(input) || isViewSnapshotEventsResponseStatus(input) || isViewSnapshotMetadata(input) || isViewSnapshotRequest(input) || isViewSnapshotResponse(input) || isViewSnapshotStreamResponse(input) || isViewTypeFilter(input) || isViewTypeOverview(input) || isViewTypeTableCol(input) || isVisualizerSettings(input) || isWebSocketInProtocol(input) || isWebSocketOutProtocol(input) || isWebUIConfig(input) || isWebUIFeatureSwitches(input);
}


export type ApiError = ApiExceptionError | BaselinePreviewError | CascadeProtectionError | ConcurrentProtectionError | DataUnavailableError | DuplicateIdsError | ElasticSearchAccessError | EventStreamMissingDataIssue | InternalError | InternalServerError | InvalidHTTPRequest | InvalidNamespaceExportError | InvalidStreamError | InvalidTimetravelMoment | NamespaceSnapshotError | NodeNotFoundError | NodesLockedError | NodesNotUnlockableError | NodesUnlockedError | NullReferenceProtectionError | ResolveError | ResourceNotFoundError | ScriptApiRouteError | ServerTimeoutError | StreamFailed | SubscriptionError | TopologyScopeError | TopologySizeOverflowError | UniqueConstraintProtectionError | UnknownAuthenticationExceptionError | ValidationErrors;

export function isApiError(input: unknown): input is ApiError {
  return isApiExceptionError(input) || isBaselinePreviewError(input) || isCascadeProtectionError(input) || isConcurrentProtectionError(input) || isDataUnavailableError(input) || isDuplicateIdsError(input) || isElasticSearchAccessError(input) || isEventStreamMissingDataIssue(input) || isInternalError(input) || isInternalServerError(input) || isInvalidHTTPRequest(input) || isInvalidNamespaceExportError(input) || isInvalidStreamError(input) || isInvalidTimetravelMoment(input) || isNamespaceSnapshotError(input) || isNodeNotFoundError(input) || isNodesLockedError(input) || isNodesNotUnlockableError(input) || isNodesUnlockedError(input) || isNullReferenceProtectionError(input) || isResolveError(input) || isResourceNotFoundError(input) || isScriptApiRouteError(input) || isServerTimeoutError(input) || isStreamFailed(input) || isSubscriptionError(input) || isTopologyScopeError(input) || isTopologySizeOverflowError(input) || isUniqueConstraintProtectionError(input) || isUnknownAuthenticationExceptionError(input) || isValidationErrors(input);
}


export interface ApiExceptionError {
  _type: Type.ApiExceptionError;
  message: string;
  errorCode: number;
}

export const isApiExceptionError = isType<ApiExceptionError>(Type.ApiExceptionError);


export type Argument = ArgumentBooleanVal | ArgumentComparatorWithoutEqualityVal | ArgumentComponentTypeRef | ArgumentDoubleVal | ArgumentDurationVal | ArgumentFailingHealthStateVal | ArgumentLongVal | ArgumentNodeIdVal | ArgumentPromQLMetricVal | ArgumentQueryViewRef | ArgumentRelationTypeRef | ArgumentStateVal | ArgumentStringVal | ArgumentStructTypeVal | ArgumentTimeWindowVal | ArgumentTopologyPromQLMetricVal | ArgumentTopologyQueryVal;

export function isArgument(input: unknown): input is Argument {
  return isArgumentBooleanVal(input) || isArgumentComparatorWithoutEqualityVal(input) || isArgumentComponentTypeRef(input) || isArgumentDoubleVal(input) || isArgumentDurationVal(input) || isArgumentFailingHealthStateVal(input) || isArgumentLongVal(input) || isArgumentNodeIdVal(input) || isArgumentPromQLMetricVal(input) || isArgumentQueryViewRef(input) || isArgumentRelationTypeRef(input) || isArgumentStateVal(input) || isArgumentStringVal(input) || isArgumentStructTypeVal(input) || isArgumentTimeWindowVal(input) || isArgumentTopologyPromQLMetricVal(input) || isArgumentTopologyQueryVal(input);
}


export interface ArgumentBooleanVal {
  _type: Type.ArgumentBooleanVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: boolean;
}

export const isArgumentBooleanVal = isType<ArgumentBooleanVal>(Type.ArgumentBooleanVal);


export interface ArgumentComparatorWithoutEqualityVal {
  _type: Type.ArgumentComparatorWithoutEqualityVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: ComparatorWithoutEquality;
}

export const isArgumentComparatorWithoutEqualityVal = isType<ArgumentComparatorWithoutEqualityVal>(Type.ArgumentComparatorWithoutEqualityVal);


export interface ArgumentComponentTypeRef {
  _type: Type.ArgumentComponentTypeRef;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  componentType: NodeId;
}

export const isArgumentComponentTypeRef = isType<ArgumentComponentTypeRef>(Type.ArgumentComponentTypeRef);


export interface ArgumentDoubleVal {
  _type: Type.ArgumentDoubleVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: number;
}

export const isArgumentDoubleVal = isType<ArgumentDoubleVal>(Type.ArgumentDoubleVal);


export interface ArgumentDurationVal {
  _type: Type.ArgumentDurationVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: number;
}

export const isArgumentDurationVal = isType<ArgumentDurationVal>(Type.ArgumentDurationVal);


export interface ArgumentFailingHealthStateVal {
  _type: Type.ArgumentFailingHealthStateVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: FailingHealthStateValue;
}

export const isArgumentFailingHealthStateVal = isType<ArgumentFailingHealthStateVal>(Type.ArgumentFailingHealthStateVal);


export interface ArgumentLongVal {
  _type: Type.ArgumentLongVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: number;
}

export const isArgumentLongVal = isType<ArgumentLongVal>(Type.ArgumentLongVal);


export interface ArgumentNodeIdVal {
  _type: Type.ArgumentNodeIdVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: number;
}

export const isArgumentNodeIdVal = isType<ArgumentNodeIdVal>(Type.ArgumentNodeIdVal);


export interface ArgumentPromQLMetricVal {
  _type: Type.ArgumentPromQLMetricVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: PromQLMetric;
}

export const isArgumentPromQLMetricVal = isType<ArgumentPromQLMetricVal>(Type.ArgumentPromQLMetricVal);


export interface ArgumentQueryViewRef {
  _type: Type.ArgumentQueryViewRef;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  queryView: NodeId;
}

export const isArgumentQueryViewRef = isType<ArgumentQueryViewRef>(Type.ArgumentQueryViewRef);


export interface ArgumentRelationTypeRef {
  _type: Type.ArgumentRelationTypeRef;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  relationType: NodeId;
}

export const isArgumentRelationTypeRef = isType<ArgumentRelationTypeRef>(Type.ArgumentRelationTypeRef);


export interface ArgumentStateVal {
  _type: Type.ArgumentStateVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: HealthStateValue;
}

export const isArgumentStateVal = isType<ArgumentStateVal>(Type.ArgumentStateVal);


export interface ArgumentStringVal {
  _type: Type.ArgumentStringVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: string;
}

export const isArgumentStringVal = isType<ArgumentStringVal>(Type.ArgumentStringVal);


export interface ArgumentStructTypeVal {
  _type: Type.ArgumentStructTypeVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: string;
}

export const isArgumentStructTypeVal = isType<ArgumentStructTypeVal>(Type.ArgumentStructTypeVal);


export interface ArgumentTimeWindowVal {
  _type: Type.ArgumentTimeWindowVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: number;
}

export const isArgumentTimeWindowVal = isType<ArgumentTimeWindowVal>(Type.ArgumentTimeWindowVal);


export interface ArgumentTopologyPromQLMetricVal {
  _type: Type.ArgumentTopologyPromQLMetricVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  value: TopologyPromQLMetric;
}

export const isArgumentTopologyPromQLMetricVal = isType<ArgumentTopologyPromQLMetricVal>(Type.ArgumentTopologyPromQLMetricVal);


export interface ArgumentTopologyQueryVal {
  _type: Type.ArgumentTopologyQueryVal;
  parameter: NodeId;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  query: string;
}

export const isArgumentTopologyQueryVal = isType<ArgumentTopologyQueryVal>(Type.ArgumentTopologyQueryVal);


export interface BaselinePreviewError {
  _type: Type.BaselinePreviewError;
  message: string;
  errorCode: number;
}

export const isBaselinePreviewError = isType<BaselinePreviewError>(Type.BaselinePreviewError);


export interface CascadeProtectionError {
  _type: Type.CascadeProtectionError;
  message: string;
  errorCode: number;
  dependentNodeNames: Array<string>;
}

export const isCascadeProtectionError = isType<CascadeProtectionError>(Type.CascadeProtectionError);


export interface Component {
  _type: Type.Component;
  labels: Array<Label>;
  state?: StackElementState;
  synced?: Array<Synced>;
  identifiers?: Array<string>;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  name: string;
  type?: NodeId;
  typeName?: string;
  typeIdentifier?: string;
  layer?: NodeId;
  layerName?: string;
  layerIdentifier?: string;
  domain?: NodeId;
  domainName?: string;
  domainIdentifier?: string;
  iconbase64?: string;
  syncedCheckStates?: Array<SyncedCheckState>;
  version?: string;
  properties?: Record<string, string>;
}

export const isComponent = isType<Component>(Type.Component);


export interface ComponentMappingFunction {
  _type: Type.ComponentMappingFunction;
  script: FunctionBody;
  parameters: Array<Parameter>;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isComponentMappingFunction = isType<ComponentMappingFunction>(Type.ComponentMappingFunction);


export interface ComponentTemplateFunction {
  _type: Type.ComponentTemplateFunction;
  handlebarsTemplate: string;
  parameters: Array<Parameter>;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isComponentTemplateFunction = isType<ComponentTemplateFunction>(Type.ComponentTemplateFunction);


export interface ComponentType {
  _type: Type.ComponentType;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  iconbase64?: string;
  highlights?: ComponentTypeHighlights;
}

export const isComponentType = isType<ComponentType>(Type.ComponentType);


export interface ComponentTypeHighlights {
  _type: Type.ComponentTypeHighlights;
  namePlural: string;
  fields: Array<ComponentTypeField>;
  about: ComponentTypeAbout;
  events: ComponentTypeEvents;
  showLogs: boolean;
  showLastChange: boolean;
  externalComponent: ComponentTypeExternalComponent;
  relatedResources: Array<ComponentTypeRelatedResources>;
  metrics: Array<ComponentTypeMetricCategory>;
}

export const isComponentTypeHighlights = isType<ComponentTypeHighlights>(Type.ComponentTypeHighlights);


export interface ConcurrentProtectionError {
  _type: Type.ConcurrentProtectionError;
  message: string;
  errorCode: number;
  nodeName: string;
}

export const isConcurrentProtectionError = isType<ConcurrentProtectionError>(Type.ConcurrentProtectionError);


export interface CreatedEvent {
  _type: Type.CreatedEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  elementId: NodeId;
  elementName?: string;
}

export const isCreatedEvent = isType<CreatedEvent>(Type.CreatedEvent);


export interface DataSource {
  _type: Type.DataSource;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  pluginId: string;
  config: StsTopologyDataSourceConfig;
  staleAfter?: number;
  propagateErrorsOnlyAfter?: number;
  uiRequestTimeout: number;
  extTopology?: ExtTopology;
}

export const isDataSource = isType<DataSource>(Type.DataSource);


export interface DataUnavailableError {
  _type: Type.DataUnavailableError;
  message: string;
  errorCode: number;
  unavailableAtEpochMs: number;
  availableSinceEpochMs: number;
}

export const isDataUnavailableError = isType<DataUnavailableError>(Type.DataUnavailableError);


export interface DeletedEvent {
  _type: Type.DeletedEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  nodeType: string;
  elementId: NodeId;
  elementName?: string;
}

export const isDeletedEvent = isType<DeletedEvent>(Type.DeletedEvent);


export interface DependSelection {
  _type: Type.DependSelection;
  root: NodeId;
  levels?: number;
}

export const isDependSelection = isType<DependSelection>(Type.DependSelection);


export interface DetailedHealthState {
  _type: Type.DetailedHealthState;
  state: HealthState;
  message?: string;
}

export const isDetailedHealthState = isType<DetailedHealthState>(Type.DetailedHealthState);


export interface DetailedServerHealth {
  _type: Type.DetailedServerHealth;
  state: DetailedHealthState;
  serviceStates: Record<string, DetailedHealthState>;
}

export const isDetailedServerHealth = isType<DetailedServerHealth>(Type.DetailedServerHealth);


export interface Domain {
  _type: Type.Domain;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  order: number;
}

export const isDomain = isType<Domain>(Type.Domain);


export interface DuplicateIdsError {
  _type: Type.DuplicateIdsError;
  message: string;
  errorCode: number;
}

export const isDuplicateIdsError = isType<DuplicateIdsError>(Type.DuplicateIdsError);


export interface ElasticSearchAccessError {
  _type: Type.ElasticSearchAccessError;
  message: string;
  errorCode: number;
}

export const isElasticSearchAccessError = isType<ElasticSearchAccessError>(Type.ElasticSearchAccessError);


export interface EmbeddingParentUpdatedEvent {
  _type: Type.EmbeddingParentUpdatedEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  parentNodeId: NodeId;
}

export const isEmbeddingParentUpdatedEvent = isType<EmbeddingParentUpdatedEvent>(Type.EmbeddingParentUpdatedEvent);


export interface ErrorsResponse {
  _type: Type.ErrorsResponse;
  trackingKey: string;
  errors: Array<ApiError>;
  serverTimestamp: number;
}

export const isErrorsResponse = isType<ErrorsResponse>(Type.ErrorsResponse);


export type Event = LifecycleEvent | StackPackStateChangeEvent | StateChangedEvent | VersionChangedEvent;

export function isEvent(input: unknown): input is Event {
  return isLifecycleEvent(input) || isStackPackStateChangeEvent(input) || isStateChangedEvent(input) || isVersionChangedEvent(input);
}


export interface EventStreamMissingDataIssue {
  _type: Type.EventStreamMissingDataIssue;
  message: string;
  errorCode: number;
}

export const isEventStreamMissingDataIssue = isType<EventStreamMissingDataIssue>(Type.EventStreamMissingDataIssue);


export interface Exporter {
  _type: Type.Exporter;
  nodesWithIds?: Array<number>;
  allNodesOfTypes?: Array<string>;
  namespace?: string;
  allowReferences?: Array<string>;
}

export const isExporter = isType<Exporter>(Type.Exporter);


export interface ExtTopoComponent {
  _type: Type.ExtTopoComponent;
  externalId?: string;
  identifiers: Array<string>;
  data: JsonRaw;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  elementTypeTag?: string;
  syncName: string;
  syncIdentifier?: string;
  sourceProperties?: Record<string, unknown>;
  status?: Record<string, unknown>;
  tags: Array<string>;
}

export const isExtTopoComponent = isType<ExtTopoComponent>(Type.ExtTopoComponent);


export type ExtTopoElement = ExtTopoComponent | ExtTopoRelation;

export function isExtTopoElement(input: unknown): input is ExtTopoElement {
  return isExtTopoComponent(input) || isExtTopoRelation(input);
}


export interface ExtTopoRelation {
  _type: Type.ExtTopoRelation;
  externalId?: string;
  identifiers: Array<string>;
  data: JsonRaw;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  elementTypeTag?: string;
  syncName: string;
  syncIdentifier?: string;
  tags: Array<string>;
}

export const isExtTopoRelation = isType<ExtTopoRelation>(Type.ExtTopoRelation);


export interface ExtTopology {
  _type: Type.ExtTopology;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  dataSource?: NodeId;
}

export const isExtTopology = isType<ExtTopology>(Type.ExtTopology);


export interface ExternalMonitor {
  _type: Type.ExternalMonitor;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  healthStreamUrn: string;
  remediationHint?: string;
  tags?: Array<string>;
}

export const isExternalMonitor = isType<ExternalMonitor>(Type.ExternalMonitor);


export type FunctionBody = NativeFunctionBody | ScriptFunctionBody;

export function isFunctionBody(input: unknown): input is FunctionBody {
  return isNativeFunctionBody(input) || isScriptFunctionBody(input);
}


export type FunctionDtoNode = ComponentMappingFunction | ExecutableComponentAction | IdExtractorFunction | MonitorFunction | RelationMappingFunction | StoredMonitorFunction;

export function isFunctionDtoNode(input: unknown): input is FunctionDtoNode {
  return isComponentMappingFunction(input) || isExecutableComponentAction(input) || isIdExtractorFunction(input) || isMonitorFunction(input) || isRelationMappingFunction(input) || isStoredMonitorFunction(input);
}


export interface GlobalStoreEvent {
  _type: Type.GlobalStoreEvent;
  event: Event;
  node?: Node;
}

export const isGlobalStoreEvent = isType<GlobalStoreEvent>(Type.GlobalStoreEvent);


export interface GlobalStoreRequest {
  _type: Type.GlobalStoreRequest;
  typeName: string;
}

export const isGlobalStoreRequest = isType<GlobalStoreRequest>(Type.GlobalStoreRequest);


export interface GlobalStoreSnapshot {
  _type: Type.GlobalStoreSnapshot;
  node: Array<Node>;
}

export const isGlobalStoreSnapshot = isType<GlobalStoreSnapshot>(Type.GlobalStoreSnapshot);


export interface GroupRelation {
  _type: Type.GroupRelation;
  id: NodeId;
  source: NodeId;
  target: NodeId;
  dependencyDirection: DependencyDirection;
  isSourceGroup: boolean;
  isTargetGroup: boolean;
  isSurjective: boolean;
  allSameDirection: boolean;
  directRelations: Array<NodeId>;
  indirectRelations: Array<NodeId>;
}

export const isGroupRelation = isType<GroupRelation>(Type.GroupRelation);


export interface HealthStateChangedEvent {
  _type: Type.HealthStateChangedEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  stackElement: NodeId;
  oldState: HealthStateValue;
  newState: HealthStateValue;
}

export const isHealthStateChangedEvent = isType<HealthStateChangedEvent>(Type.HealthStateChangedEvent);


export interface IdExtractorFunction {
  _type: Type.IdExtractorFunction;
  script: FunctionBody;
  parameters: Array<Parameter>;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  groovyScript: FunctionBody;
}

export const isIdExtractorFunction = isType<IdExtractorFunction>(Type.IdExtractorFunction);


export interface IndirectRelation {
  _type: Type.IndirectRelation;
  id: NodeId;
  source: NodeId;
  target: NodeId;
  dependencyDirection: DependencyDirection;
  paths: TopologyPaths;
}

export const isIndirectRelation = isType<IndirectRelation>(Type.IndirectRelation);


export interface InternalError {
  _type: Type.InternalError;
  message: string;
  errorCode: number;
}

export const isInternalError = isType<InternalError>(Type.InternalError);


export interface InternalServerError {
  _type: Type.InternalServerError;
  message: string;
  errorCode: number;
}

export const isInternalServerError = isType<InternalServerError>(Type.InternalServerError);


export interface InvalidHTTPRequest {
  _type: Type.InvalidHTTPRequest;
  message: string;
  errorCode: number;
}

export const isInvalidHTTPRequest = isType<InvalidHTTPRequest>(Type.InvalidHTTPRequest);


export interface InvalidNamespaceExportError {
  _type: Type.InvalidNamespaceExportError;
  message: string;
  errorCode: number;
  detail: Record<string, string>;
}

export const isInvalidNamespaceExportError = isType<InvalidNamespaceExportError>(Type.InvalidNamespaceExportError);


export interface InvalidStreamError {
  _type: Type.InvalidStreamError;
  message: string;
  errorCode: number;
}

export const isInvalidStreamError = isType<InvalidStreamError>(Type.InvalidStreamError);


export interface InvalidTimetravelMoment {
  _type: Type.InvalidTimetravelMoment;
  message: string;
  errorCode: number;
  requestedEpoch: number;
  currentEpoch: number;
}

export const isInvalidTimetravelMoment = isType<InvalidTimetravelMoment>(Type.InvalidTimetravelMoment);


export interface KeepAlive {
  _type: Type.KeepAlive;

}

export const isKeepAlive = isType<KeepAlive>(Type.KeepAlive);


export interface Label {
  _type: Type.Label;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  name: string;
}

export const isLabel = isType<Label>(Type.Label);


export interface Layer {
  _type: Type.Layer;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  order: number;
}

export const isLayer = isType<Layer>(Type.Layer);


export type LifecycleEvent = CreatedEvent | DeletedEvent | EmbeddingParentUpdatedEvent | UpdatedEvent;

export function isLifecycleEvent(input: unknown): input is LifecycleEvent {
  return isCreatedEvent(input) || isDeletedEvent(input) || isEmbeddingParentUpdatedEvent(input) || isUpdatedEvent(input);
}


export type LockedResponse = NodeLocked | NodeUnLocked;

export function isLockedResponse(input: unknown): input is LockedResponse {
  return isNodeLocked(input) || isNodeUnLocked(input);
}


export interface LoginInfo {
  _type: Type.LoginInfo;
  forgotPasswordLink?: string;
  authProvider: PrimaryAuthProvider;
  skipLoginPage: boolean;
}

export const isLoginInfo = isType<LoginInfo>(Type.LoginInfo);


export type MappingFunction = ComponentMappingFunction | RelationMappingFunction;

export function isMappingFunction(input: unknown): input is MappingFunction {
  return isComponentMappingFunction(input) || isRelationMappingFunction(input);
}


export interface Monitor {
  _type: Type.Monitor;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  function: NodeId;
  arguments: Array<Argument>;
  remediationHint?: string;
  intervalSeconds: number;
  tags?: Array<string>;
  status?: MonitorStatusValue;
  dummy?: boolean;
}

export const isMonitor = isType<Monitor>(Type.Monitor);


export interface MonitorFunction {
  _type: Type.MonitorFunction;
  script: FunctionBody;
  parameters: Array<Parameter>;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  triggerOn?: TriggerOnTemplate;
}

export const isMonitorFunction = isType<MonitorFunction>(Type.MonitorFunction);


export type NamableNode = ApiToken | ExecutableComponentAction | ResolvableNameableNode | ServiceToken;

export function isNamableNode(input: unknown): input is NamableNode {
  return isApiToken(input) || isExecutableComponentAction(input) || isResolvableNameableNode(input) || isServiceToken(input);
}


export interface NamespaceSnapshotError {
  _type: Type.NamespaceSnapshotError;
  message: string;
  errorCode: number;
}

export const isNamespaceSnapshotError = isType<NamespaceSnapshotError>(Type.NamespaceSnapshotError);


export interface NativeFunctionBody {
  _type: Type.NativeFunctionBody;
  nativeFunctionBodyId: NativeFunctionBodyId;
}

export const isNativeFunctionBody = isType<NativeFunctionBody>(Type.NativeFunctionBody);


export type Node = Argument | ExtTopoElement | ExtTopology | Label | ObservabilityPermission | ObservabilitySubject | OptionallyNamableNode | Parameter | PromQLMetric | ResolvableNode | StackPackConfiguration | StsTopologyDataSourceConfig | StsTopologyElementsQuery | SyncAction | Synced | TopologyPromQLMetric | TopologySyncSettings | ViewElement;

export function isNode(input: unknown): input is Node {
  return isArgument(input) || isExtTopoElement(input) || isExtTopology(input) || isLabel(input) || isObservabilityPermission(input) || isObservabilitySubject(input) || isOptionallyNamableNode(input) || isParameter(input) || isPromQLMetric(input) || isResolvableNode(input) || isStackPackConfiguration(input) || isStsTopologyDataSourceConfig(input) || isStsTopologyElementsQuery(input) || isSyncAction(input) || isSynced(input) || isTopologyPromQLMetric(input) || isTopologySyncSettings(input) || isViewElement(input);
}


export type NodeLike = Node | StackElementState;

export function isNodeLike(input: unknown): input is NodeLike {
  return isNode(input) || isStackElementState(input);
}


export interface NodeLocked {
  _type: Type.NodeLocked;
  owner: string;
}

export const isNodeLocked = isType<NodeLocked>(Type.NodeLocked);


export interface NodeNotFoundError {
  _type: Type.NodeNotFoundError;
  message: string;
  errorCode: number;
  identifier: string;
}

export const isNodeNotFoundError = isType<NodeNotFoundError>(Type.NodeNotFoundError);


export interface NodeUnLocked {
  _type: Type.NodeUnLocked;

}

export const isNodeUnLocked = isType<NodeUnLocked>(Type.NodeUnLocked);


export interface NodesLockedError {
  _type: Type.NodesLockedError;
  message: string;
  errorCode: number;
  nodeNames: Array<string>;
}

export const isNodesLockedError = isType<NodesLockedError>(Type.NodesLockedError);


export interface NodesNotUnlockableError {
  _type: Type.NodesNotUnlockableError;
  message: string;
  errorCode: number;
  nodeNames: Array<string>;
}

export const isNodesNotUnlockableError = isType<NodesNotUnlockableError>(Type.NodesNotUnlockableError);


export interface NodesUnlockedError {
  _type: Type.NodesUnlockedError;
  message: string;
  errorCode: number;
  nodeNames: Array<string>;
}

export const isNodesUnlockedError = isType<NodesUnlockedError>(Type.NodesUnlockedError);


export interface NullReferenceProtectionError {
  _type: Type.NullReferenceProtectionError;
  message: string;
  errorCode: number;
  dependentNodeNames: Array<string>;
}

export const isNullReferenceProtectionError = isType<NullReferenceProtectionError>(Type.NullReferenceProtectionError);


export interface OnlineTrialAttributes {
  _type: Type.OnlineTrialAttributes;
  startTimestampMs: number;
  expiryTimestampMs: number;
}

export const isOnlineTrialAttributes = isType<OnlineTrialAttributes>(Type.OnlineTrialAttributes);


export type OptionallyNamableNode = NamableNode | StackElement;

export function isOptionallyNamableNode(input: unknown): input is OptionallyNamableNode {
  return isNamableNode(input) || isStackElement(input);
}


export interface Parameter {
  _type: Type.Parameter;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  name: string;
  type: ParameterType;
  multiple: boolean;
  required: boolean;
  extraAcceptedParameterTypes?: Array<ParameterType>;
}

export const isParameter = isType<Parameter>(Type.Parameter);

export enum PrimaryAuthProvider {
  StackstateAuthServer = "stackstateAuthServer",
  KeycloakAuthServer = "keycloakAuthServer",
  OidcAuthServer = "oidcAuthServer",
  LdapAuthServer = "ldapAuthServer",
}


export interface KeycloakAuthServer {
  _type: Type.KeycloakAuthServer;

}

export const isKeycloakAuthServer = isType<KeycloakAuthServer>(Type.KeycloakAuthServer);


export interface LdapAuthServer {
  _type: Type.LdapAuthServer;

}

export const isLdapAuthServer = isType<LdapAuthServer>(Type.LdapAuthServer);


export interface OidcAuthServer {
  _type: Type.OidcAuthServer;

}

export const isOidcAuthServer = isType<OidcAuthServer>(Type.OidcAuthServer);


export interface StackstateAuthServer {
  _type: Type.StackstateAuthServer;

}

export const isStackstateAuthServer = isType<StackstateAuthServer>(Type.StackstateAuthServer);


export interface PromQLMetric {
  _type: Type.PromQLMetric;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  query: string;
  unit: string;
  aliasTemplate: string;
}

export const isPromQLMetric = isType<PromQLMetric>(Type.PromQLMetric);


export interface QueryMetadata {
  _type: Type.QueryMetadata;
  groupingEnabled: boolean;
  showIndirectRelations: boolean;
  minGroupSize: number;
  groupedByLayer: boolean;
  groupedByDomain: boolean;
  groupedByRelation: boolean;
  queryTime?: number;
  autoGrouping: boolean;
  connectedComponents: boolean;
  neighboringComponents: boolean;
  showFullComponent: boolean;
}

export const isQueryMetadata = isType<QueryMetadata>(Type.QueryMetadata);


export interface QueryParsingFailure {
  _type: Type.QueryParsingFailure;
  reason: string;
}

export const isQueryParsingFailure = isType<QueryParsingFailure>(Type.QueryParsingFailure);


export type QuerySnapshotResponse = QueryParsingFailure | QuerySnapshotResult;

export function isQuerySnapshotResponse(input: unknown): input is QuerySnapshotResponse {
  return isQueryParsingFailure(input) || isQuerySnapshotResult(input);
}


export interface QuerySnapshotResult {
  _type: Type.QuerySnapshotResult;
  viewSnapshotResponse: ViewSnapshotResponse;
}

export const isQuerySnapshotResult = isType<QuerySnapshotResult>(Type.QuerySnapshotResult);


export interface QueryStreamRequest {
  _type: Type.QueryStreamRequest;
  query: string;
  queryVersion: Version;
  metadata: QueryMetadata;
}

export const isQueryStreamRequest = isType<QueryStreamRequest>(Type.QueryStreamRequest);


export interface QueryView {
  _type: Type.QueryView;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  groupedByDomains: boolean;
  groupedByLayers: boolean;
  groupedByRelations: boolean;
  showIndirectRelations: boolean;
  groupingEnabled: boolean;
  minimumGroupSize: number;
  query: string;
  queryVersion: Version;
  eventFilters?: ViewEventFilters;
  tags?: Array<string>;
  autoGrouping: boolean;
  connectedComponents: boolean;
  neighboringComponents: boolean;
  viewType?: string;
  flags?: Array<ViewFlagValue>;
}

export const isQueryView = isType<QueryView>(Type.QueryView);


export interface Relation {
  _type: Type.Relation;
  labels: Array<Label>;
  state?: StackElementState;
  synced?: Array<Synced>;
  identifiers?: Array<string>;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  name?: string;
  type?: NodeId;
  typeName?: string;
  typeIdentifier?: string;
  syncedCheckStates?: Array<SyncedCheckState>;
  dependencyDirection: DependencyDirection;
  source: NodeId;
  target: NodeId;
}

export const isRelation = isType<Relation>(Type.Relation);


export interface RelationMappingFunction {
  _type: Type.RelationMappingFunction;
  script: FunctionBody;
  parameters: Array<Parameter>;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isRelationMappingFunction = isType<RelationMappingFunction>(Type.RelationMappingFunction);


export interface RelationTemplateFunction {
  _type: Type.RelationTemplateFunction;
  handlebarsTemplate: string;
  parameters: Array<Parameter>;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isRelationTemplateFunction = isType<RelationTemplateFunction>(Type.RelationTemplateFunction);


export interface RelationType {
  _type: Type.RelationType;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  dependencyType: DependencyType;
}

export const isRelationType = isType<RelationType>(Type.RelationType);


export type ResolvableNameableNode = ComponentActionDefinition | ComponentHighlightMetricSection | ComponentType | Dashboard | DashboardBackup | DataSource | Domain | ExternalMonitor | IdExtractorFunction | Layer | MainMenuGroup | MappingFunction | MetricBinding | MetricPerspectiveSection | MetricPerspectiveTab | Monitor | MonitorFunction | OtelComponentMapping | OtelRelationMapping | QueryView | RelationType | SpanToComponentBinding | Sync | TemplateFunction | TraceBinding | UserProfile | ViewType;

export function isResolvableNameableNode(input: unknown): input is ResolvableNameableNode {
  return isComponentActionDefinition(input) || isComponentHighlightMetricSection(input) || isComponentType(input) || isDashboard(input) || isDashboardBackup(input) || isDataSource(input) || isDomain(input) || isExternalMonitor(input) || isIdExtractorFunction(input) || isLayer(input) || isMainMenuGroup(input) || isMappingFunction(input) || isMetricBinding(input) || isMetricPerspectiveSection(input) || isMetricPerspectiveTab(input) || isMonitor(input) || isMonitorFunction(input) || isOtelComponentMapping(input) || isOtelRelationMapping(input) || isQueryView(input) || isRelationType(input) || isSpanToComponentBinding(input) || isSync(input) || isTemplateFunction(input) || isTraceBinding(input) || isUserProfile(input) || isViewType(input);
}


export type ResolvableNode = ResolvableNameableNode;

export function isResolvableNode(input: unknown): input is ResolvableNode {
  return isResolvableNameableNode(input);
}


export interface ResolveError {
  _type: Type.ResolveError;
  message: string;
  errorCode: number;
}

export const isResolveError = isType<ResolveError>(Type.ResolveError);


export interface ResourceNotFoundError {
  _type: Type.ResourceNotFoundError;
  message: string;
  errorCode: number;
}

export const isResourceNotFoundError = isType<ResourceNotFoundError>(Type.ResourceNotFoundError);


export interface RestrictedViewComponent {
  _type: Type.RestrictedViewComponent;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isRestrictedViewComponent = isType<RestrictedViewComponent>(Type.RestrictedViewComponent);


export interface RestrictedViewRelation {
  _type: Type.RestrictedViewRelation;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isRestrictedViewRelation = isType<RestrictedViewRelation>(Type.RestrictedViewRelation);


export interface ScriptApiRouteError {
  _type: Type.ScriptApiRouteError;
  message: string;
  errorCode: number;
  reason?: string;
}

export const isScriptApiRouteError = isType<ScriptApiRouteError>(Type.ScriptApiRouteError);


export interface ScriptFunctionBody {
  _type: Type.ScriptFunctionBody;
  scriptBody: string;
}

export const isScriptFunctionBody = isType<ScriptFunctionBody>(Type.ScriptFunctionBody);


export interface ServerHealth {
  _type: Type.ServerHealth;
  status: HealthState;
}

export const isServerHealth = isType<ServerHealth>(Type.ServerHealth);


export interface ServerSuppliedWebUIConfig {
  _type: Type.ServerSuppliedWebUIConfig;
  runMode: RunMode;
  enableAi: boolean;
  webUIConfig: WebUIConfig;
  isGuiAuth: boolean;
  queryVersion: Version;
  serverVersion: Version;
  stqlConfig: StqlParserConfig;
  onlineTrialAttributes?: OnlineTrialAttributes;
  subscription: SubscriptionState;
  deploymentMode: DeploymentMode;
  edition: Edition;
  applicationDomains: Array<ApplicationDomain>;
}

export const isServerSuppliedWebUIConfig = isType<ServerSuppliedWebUIConfig>(Type.ServerSuppliedWebUIConfig);


export interface ServerTimeoutError {
  _type: Type.ServerTimeoutError;
  message: string;
  errorCode: number;
  timeoutSeconds?: number;
}

export const isServerTimeoutError = isType<ServerTimeoutError>(Type.ServerTimeoutError);


export interface SingleNonDeterministicTopologyPath {
  _type: Type.SingleNonDeterministicTopologyPath;
  path: TopologyPath;
}

export const isSingleNonDeterministicTopologyPath = isType<SingleNonDeterministicTopologyPath>(Type.SingleNonDeterministicTopologyPath);


export type SocketStreamRequest = GlobalStoreRequest | PermissionStreamRequest | QueryStreamRequest | StatusUpdateRequest;

export function isSocketStreamRequest(input: unknown): input is SocketStreamRequest {
  return isGlobalStoreRequest(input) || isPermissionStreamRequest(input) || isQueryStreamRequest(input) || isStatusUpdateRequest(input);
}


export type StackElement = Component | Relation;

export function isStackElement(input: unknown): input is StackElement {
  return isComponent(input) || isRelation(input);
}


export interface StackElementState {
  _type: Type.StackElementState;
  id: NodeId;
  lastUpdateTimestamp?: number;
  healthState: HealthStateValue;
}

export const isStackElementState = isType<StackElementState>(Type.StackElementState);


export interface StackPackResourceConfig {
  _type: Type.StackPackResourceConfig;
  baseUrl: string;
  apiKey?: string;
}

export const isStackPackResourceConfig = isType<StackPackResourceConfig>(Type.StackPackResourceConfig);


export interface StackPackStateChangeEvent {
  _type: Type.StackPackStateChangeEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  stackPackConfiguration: StackPackConfiguration;
  stackPackName: string;
  error?: StackPackError;
}

export const isStackPackStateChangeEvent = isType<StackPackStateChangeEvent>(Type.StackPackStateChangeEvent);


export type StateChangedEvent = HealthStateChangedEvent;

export function isStateChangedEvent(input: unknown): input is StateChangedEvent {
  return isHealthStateChangedEvent(input);
}


export interface StatusUpdateRequest {
  _type: Type.StatusUpdateRequest;
  updateType: StatusUpdateType;
}

export const isStatusUpdateRequest = isType<StatusUpdateRequest>(Type.StatusUpdateRequest);

export enum StatusUpdateType {
  StackPackUpdate = "StackPackUpdate",
}


export interface StoredExternalMonitor {
  _type: Type.StoredExternalMonitor;
  id: NodeId;
  lastUpdateTimestamp: number;
  identifier?: string;
  ownedBy?: string;
  name: string;
  description?: string;
  healthStreamUrn: string;
  remediationHint?: string;
  tags?: Array<string>;
}

export const isStoredExternalMonitor = isType<StoredExternalMonitor>(Type.StoredExternalMonitor);


export interface StoredMonitor {
  _type: Type.StoredMonitor;
  id: NodeId;
  lastUpdateTimestamp: number;
  identifier?: string;
  ownedBy?: string;
  name: string;
  description?: string;
  function: NodeId;
  arguments: Array<Argument>;
  remediationHint?: string;
  intervalSeconds: number;
  tags?: Array<string>;
  status: MonitorStatusValue;
  dummy?: boolean;
}

export const isStoredMonitor = isType<StoredMonitor>(Type.StoredMonitor);


export interface StoredMonitorFunction {
  _type: Type.StoredMonitorFunction;
  script: FunctionBody;
  parameters: Array<Parameter>;
  id: NodeId;
  lastUpdateTimestamp: number;
  identifier?: string;
  ownedBy?: string;
  name: string;
  description?: string;
  triggerOn?: TriggerOnTemplate;
}

export const isStoredMonitorFunction = isType<StoredMonitorFunction>(Type.StoredMonitorFunction);


export type StoredNode = StoredExternalMonitor | StoredMonitor | StoredMonitorFunction;

export function isStoredNode(input: unknown): input is StoredNode {
  return isStoredExternalMonitor(input) || isStoredMonitor(input) || isStoredMonitorFunction(input);
}


export interface StreamFailed {
  _type: Type.StreamFailed;
  message: string;
  errorCode: number;
}

export const isStreamFailed = isType<StreamFailed>(Type.StreamFailed);


export type StringEnum = Activities | Alerts | Anomalies | Changes | ConfigurationChangedEventType | CreateComponentPresentations | CreateDashboards | CreateFavoriteDashboards | CreateFavoriteViews | CreateMetricBindings | CreateMonitors | CreateNotifications | CreateOtelMappings | CreateServiceTokens | CreateStackpackConfigurations | CreateViews | DeleteComponentPresentations | DeleteDashboards | DeleteFavoriteDashboards | DeleteFavoriteViews | DeleteMetricBindings | DeleteMonitors | DeleteNotifications | DeleteOtelMappings | DeleteServiceTokens | DeleteStackpackConfigurations | DeleteStackpacks | DeleteSyncData | DeleteViews | Deployments | ElementCreatedEventType | ElementDeletedEventType | ElementUpdatedEventType | ExecuteAi | ExecuteComponentActions | ExecuteMonitors | ExecuteRestrictedScripts | ExecuteScripts | GetAgents | GetApiTokens | GetComponentPresentations | GetDashboards | GetMetricBindings | GetMetrics | GetMonitors | GetNotifications | GetOtelMappings | GetPermissions | GetServiceTokens | GetSettings | GetStackpacks | GetSyncData | GetSystemNotifications | GetTopicMessages | GetTopology | GetTraces | GetViews | HealthStateChangedEventType | High | HigherIsBetter | Invalid | KeycloakAuthServer | LdapAuthServer | Line | Low | LowerIsBetter | Medium | MetricStreamAnomalyEventType | Missing | None | OidcAuthServer | Others | RunStateChangedEventType | StackstateAuthServer | UnlockSettings | UpdateComponentPresentations | UpdateDashboards | UpdateMetricBindings | UpdateMetrics | UpdateMonitors | UpdateNotifications | UpdateOtelMappings | UpdatePermissions | UpdateScopedPermissions | UpdateSettings | UpdateStackpackConfigurations | UpdateStackpacks | UpdateViews | UpdateVisualization | VersionChangedEventType;

export function isStringEnum(input: unknown): input is StringEnum {
  return isActivities(input) || isAlerts(input) || isAnomalies(input) || isChanges(input) || isConfigurationChangedEventType(input) || isCreateComponentPresentations(input) || isCreateDashboards(input) || isCreateFavoriteDashboards(input) || isCreateFavoriteViews(input) || isCreateMetricBindings(input) || isCreateMonitors(input) || isCreateNotifications(input) || isCreateOtelMappings(input) || isCreateServiceTokens(input) || isCreateStackpackConfigurations(input) || isCreateViews(input) || isDeleteComponentPresentations(input) || isDeleteDashboards(input) || isDeleteFavoriteDashboards(input) || isDeleteFavoriteViews(input) || isDeleteMetricBindings(input) || isDeleteMonitors(input) || isDeleteNotifications(input) || isDeleteOtelMappings(input) || isDeleteServiceTokens(input) || isDeleteStackpackConfigurations(input) || isDeleteStackpacks(input) || isDeleteSyncData(input) || isDeleteViews(input) || isDeployments(input) || isElementCreatedEventType(input) || isElementDeletedEventType(input) || isElementUpdatedEventType(input) || isExecuteAi(input) || isExecuteComponentActions(input) || isExecuteMonitors(input) || isExecuteRestrictedScripts(input) || isExecuteScripts(input) || isGetAgents(input) || isGetApiTokens(input) || isGetComponentPresentations(input) || isGetDashboards(input) || isGetMetricBindings(input) || isGetMetrics(input) || isGetMonitors(input) || isGetNotifications(input) || isGetOtelMappings(input) || isGetPermissions(input) || isGetServiceTokens(input) || isGetSettings(input) || isGetStackpacks(input) || isGetSyncData(input) || isGetSystemNotifications(input) || isGetTopicMessages(input) || isGetTopology(input) || isGetTraces(input) || isGetViews(input) || isHealthStateChangedEventType(input) || isHigh(input) || isHigherIsBetter(input) || isInvalid(input) || isKeycloakAuthServer(input) || isLdapAuthServer(input) || isLine(input) || isLow(input) || isLowerIsBetter(input) || isMedium(input) || isMetricStreamAnomalyEventType(input) || isMissing(input) || isNone(input) || isOidcAuthServer(input) || isOthers(input) || isRunStateChangedEventType(input) || isStackstateAuthServer(input) || isUnlockSettings(input) || isUpdateComponentPresentations(input) || isUpdateDashboards(input) || isUpdateMetricBindings(input) || isUpdateMetrics(input) || isUpdateMonitors(input) || isUpdateNotifications(input) || isUpdateOtelMappings(input) || isUpdatePermissions(input) || isUpdateScopedPermissions(input) || isUpdateSettings(input) || isUpdateStackpackConfigurations(input) || isUpdateStackpacks(input) || isUpdateViews(input) || isUpdateVisualization(input) || isVersionChangedEventType(input);
}


export interface StsTopologyDataSourceConfig {
  _type: Type.StsTopologyDataSourceConfig;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  integrationType: string;
  topic: string;
  autoExpireElements: boolean;
  expireElementsAfter: number;
}

export const isStsTopologyDataSourceConfig = isType<StsTopologyDataSourceConfig>(Type.StsTopologyDataSourceConfig);


export interface SubscriptionError {
  _type: Type.SubscriptionError;
  message: string;
  errorCode: number;
  subscriptionState: SubscriptionState;
}

export const isSubscriptionError = isType<SubscriptionError>(Type.SubscriptionError);


export interface Sync {
  _type: Type.Sync;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  componentActions: Array<SyncActionComponent>;
  relationActions: Array<SyncActionRelation>;
  defaultComponentAction: SyncActionComponent;
  defaultRelationAction: SyncActionRelation;
  extTopology?: NodeId;
  topologyDataQuery: StsTopologyElementsQuery;
  state?: SyncState;
}

export const isSync = isType<Sync>(Type.Sync);


export type SyncAction = SyncActionComponent | SyncActionCreate | SyncActionRelation;

export function isSyncAction(input: unknown): input is SyncAction {
  return isSyncActionComponent(input) || isSyncActionCreate(input) || isSyncActionRelation(input);
}


export type SyncActionComponent = SyncActionCreateComponent | SyncActionCreateOnMerge;

export function isSyncActionComponent(input: unknown): input is SyncActionComponent {
  return isSyncActionCreateComponent(input) || isSyncActionCreateOnMerge(input);
}


export type SyncActionCreate = SyncActionCreateComponent | SyncActionCreateRelation;

export function isSyncActionCreate(input: unknown): input is SyncActionCreate {
  return isSyncActionCreateComponent(input) || isSyncActionCreateRelation(input);
}


export interface SyncActionCreateComponent {
  _type: Type.SyncActionCreateComponent;
  mappingFunction?: NodeId;
  templateFunction: NodeId;
  mergeStrategy: MergeStrategy;
  type: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isSyncActionCreateComponent = isType<SyncActionCreateComponent>(Type.SyncActionCreateComponent);


export interface SyncActionCreateOnMerge {
  _type: Type.SyncActionCreateOnMerge;
  type: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isSyncActionCreateOnMerge = isType<SyncActionCreateOnMerge>(Type.SyncActionCreateOnMerge);


export interface SyncActionCreateRelation {
  _type: Type.SyncActionCreateRelation;
  mappingFunction?: NodeId;
  templateFunction: NodeId;
  mergeStrategy: MergeStrategy;
  type: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isSyncActionCreateRelation = isType<SyncActionCreateRelation>(Type.SyncActionCreateRelation);


export type SyncActionRelation = SyncActionCreateOnMerge | SyncActionCreateRelation;

export function isSyncActionRelation(input: unknown): input is SyncActionRelation {
  return isSyncActionCreateOnMerge(input) || isSyncActionCreateRelation(input);
}


export interface SyncState {
  _type: Type.SyncState;
  createdComponents: number;
  deletedComponents: number;
  createdRelations: number;
  deletedRelations: number;
  errors: number;
}

export const isSyncState = isType<SyncState>(Type.SyncState);


export interface Synced {
  _type: Type.Synced;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  extTopologyElement?: ExtTopoElement;
}

export const isSynced = isType<Synced>(Type.Synced);


export interface TemplateExecutionRequest {
  _type: Type.TemplateExecutionRequest;
  arguments: Array<Argument>;
  element: Record<string, unknown>;
}

export const isTemplateExecutionRequest = isType<TemplateExecutionRequest>(Type.TemplateExecutionRequest);


export type TemplateFunction = ComponentTemplateFunction | RelationTemplateFunction;

export function isTemplateFunction(input: unknown): input is TemplateFunction {
  return isComponentTemplateFunction(input) || isRelationTemplateFunction(input);
}


export interface TopologyPath {
  _type: Type.TopologyPath;
  elements: Array<TopologyPathElement>;
  components: Array<ViewComponentBase>;
  relations: Array<ViewRelationBase>;
}

export const isTopologyPath = isType<TopologyPath>(Type.TopologyPath);


export interface ComponentPathElement {
  _type: Type.ComponentPathElement;
  id: number;
}

export const isComponentPathElement = isType<ComponentPathElement>(Type.ComponentPathElement);


export interface RelationPathElement {
  _type: Type.RelationPathElement;
  id: number;
}

export const isRelationPathElement = isType<RelationPathElement>(Type.RelationPathElement);


export type TopologyPathElement = ComponentPathElement | RelationPathElement;

export function isTopologyPathElement(input: unknown): input is TopologyPathElement {
  return isComponentPathElement(input) || isRelationPathElement(input);
}


export interface TopologyPathExistsDeeperThan {
  _type: Type.TopologyPathExistsDeeperThan;
  depth: number;
}

export const isTopologyPathExistsDeeperThan = isType<TopologyPathExistsDeeperThan>(Type.TopologyPathExistsDeeperThan);


export type TopologyPaths = SingleNonDeterministicTopologyPath | TopologyPathExistsDeeperThan;

export function isTopologyPaths(input: unknown): input is TopologyPaths {
  return isSingleNonDeterministicTopologyPath(input) || isTopologyPathExistsDeeperThan(input);
}


export interface TopologyPromQLMetric {
  _type: Type.TopologyPromQLMetric;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  topologyQuery: string;
  promQLQuery: string;
  unit: string;
  aliasTemplate: string;
}

export const isTopologyPromQLMetric = isType<TopologyPromQLMetric>(Type.TopologyPromQLMetric);


export interface TopologyScopeError {
  _type: Type.TopologyScopeError;
  message: string;
  errorCode: number;
}

export const isTopologyScopeError = isType<TopologyScopeError>(Type.TopologyScopeError);


export interface TopologySizeOverflowError {
  _type: Type.TopologySizeOverflowError;
  message: string;
  errorCode: number;
}

export const isTopologySizeOverflowError = isType<TopologySizeOverflowError>(Type.TopologySizeOverflowError);


export interface TopologySyncSettings {
  _type: Type.TopologySyncSettings;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isTopologySyncSettings = isType<TopologySyncSettings>(Type.TopologySyncSettings);


export interface TypeGroup {
  _type: Type.TypeGroup;
  id: NodeId;
  classifier: TypeGroupClassifier;
  layers: Array<string>;
  domains: Array<string>;
  components: Array<NodeId>;
}

export const isTypeGroup = isType<TypeGroup>(Type.TypeGroup);


export interface TypeGroupClassifier {
  _type: Type.TypeGroupClassifier;
  componentTypeIdentifier: string;
  health: HealthStateValue;
  layerIdentifier: string;
  domainIdentifier: string;
  incomingRelations: Array<NodeId>;
  outgoingRelations: Array<NodeId>;
  retrievalSource: ViewElementRetrievalSource;
  hasRelations: boolean;
}

export const isTypeGroupClassifier = isType<TypeGroupClassifier>(Type.TypeGroupClassifier);


export interface UniqueConstraintProtectionError {
  _type: Type.UniqueConstraintProtectionError;
  message: string;
  errorCode: number;
  detail: Record<string, Array<string>>;
}

export const isUniqueConstraintProtectionError = isType<UniqueConstraintProtectionError>(Type.UniqueConstraintProtectionError);


export interface UnknownAuthenticationExceptionError {
  _type: Type.UnknownAuthenticationExceptionError;
  message: string;
  errorCode: number;
}

export const isUnknownAuthenticationExceptionError = isType<UnknownAuthenticationExceptionError>(Type.UnknownAuthenticationExceptionError);

export enum UnlockedStrategy {
  Skip = "skip",
  Fail = "fail",
  Overwrite = "overwrite",
}


export interface UpdatedEvent {
  _type: Type.UpdatedEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  elementId: NodeId;
  elementName?: string;
}

export const isUpdatedEvent = isType<UpdatedEvent>(Type.UpdatedEvent);


export interface ValidationErrors {
  _type: Type.ValidationErrors;
  message: string;
  errorCode: number;
  errors: Array<string>;
  fieldErrors: Record<string, Array<string>>;
}

export const isValidationErrors = isType<ValidationErrors>(Type.ValidationErrors);


export type Version = Brand<string, "Version">;


export interface VersionChangedEvent {
  _type: Type.VersionChangedEvent;
  triggeredTimestamp: number;
  transactionId: number;
  identifier: string;
  elementId: NodeId;
  elementName?: string;
  oldVersion?: string;
  newVersion?: string;
}

export const isVersionChangedEvent = isType<VersionChangedEvent>(Type.VersionChangedEvent);


export interface ViewCheck {
  _type: Type.ViewCheck;
  id: NodeId;
  lastUpdateTimestamp: number;
  name: string;
  description?: string;
  state: ViewCheckState;
}

export const isViewCheck = isType<ViewCheck>(Type.ViewCheck);


export interface ViewCheckState {
  _type: Type.ViewCheckState;
  state: HealthStateValue;
  lastUpdateTimestamp: number;
}

export const isViewCheckState = isType<ViewCheckState>(Type.ViewCheckState);


export interface ViewComponent {
  _type: Type.ViewComponent;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  name: string;
  description?: string;
  typeIdentifier: string;
  layerIdentifier: string;
  domainIdentifier: string;
  state?: StackElementState;
  outgoingRelations?: Array<NodeId>;
  incomingRelations?: Array<NodeId>;
  synchronized: boolean;
  failingChecks?: Array<ViewCheck>;
  iconbase64?: string;
  retrievalSource: ViewElementRetrievalSource;
  identifiers?: Array<string>;
  tags?: Array<string>;
  properties?: Record<string, string>;
}

export const isViewComponent = isType<ViewComponent>(Type.ViewComponent);


export type ViewComponentBase = RestrictedViewComponent | ViewComponent;

export function isViewComponentBase(input: unknown): input is ViewComponentBase {
  return isRestrictedViewComponent(input) || isViewComponent(input);
}


export type ViewElement = ViewComponentBase | ViewRelationBase;

export function isViewElement(input: unknown): input is ViewElement {
  return isViewComponentBase(input) || isViewRelationBase(input);
}

export enum ViewElementRetrievalSource {
  Query = "QUERY",
  VisualizerSettings = "VISUALIZER_SETTINGS",
}


export interface ViewEventFilters {
  _type: Type.ViewEventFilters;
  types?: Array<string>;
  tags?: Array<string>;
  categories?: Array<string>;
  sources?: Array<string>;
}

export const isViewEventFilters = isType<ViewEventFilters>(Type.ViewEventFilters);


export interface ViewRelation {
  _type: Type.ViewRelation;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  name?: string;
  description?: string;
  typeIdentifier: string;
  source: NodeId;
  target: NodeId;
  dependencyDirection: DependencyDirection;
  synchronized: boolean;
  failingChecks: Array<ViewCheck>;
  state?: StackElementState;
  identifiers?: Array<string>;
}

export const isViewRelation = isType<ViewRelation>(Type.ViewRelation);


export type ViewRelationBase = RestrictedViewRelation | ViewRelation;

export function isViewRelationBase(input: unknown): input is ViewRelationBase {
  return isRestrictedViewRelation(input) || isViewRelation(input);
}


export interface ViewSnapshot {
  _type: Type.ViewSnapshot;
  components: Array<ViewComponent>;
  relations: Array<ViewRelation>;
  indirectRelations: Array<IndirectRelation>;
  groups: Array<TypeGroup>;
  groupRelations: Array<GroupRelation>;
  metadata: ViewSnapshotMetadata;
  traversalResult: ViewTraversalResult;
}

export const isViewSnapshot = isType<ViewSnapshot>(Type.ViewSnapshot);


export interface ViewSnapshotDataUnavailable {
  _type: Type.ViewSnapshotDataUnavailable;
  unavailableAtEpochMs: number;
  availableSinceEpochMs: number;
}

export const isViewSnapshotDataUnavailable = isType<ViewSnapshotDataUnavailable>(Type.ViewSnapshotDataUnavailable);


export interface ViewSnapshotDiff {
  _type: Type.ViewSnapshotDiff;
  addedComponents: Array<ViewComponent>;
  addedRelations: Array<ViewRelation>;
  addedIndirectRelations: Array<IndirectRelation>;
  addedGroups: Array<TypeGroup>;
  addedGroupRelations: Array<GroupRelation>;
  updatedComponents: Array<ViewComponent>;
  updatedRelations: Array<ViewRelation>;
  updatedGroups: Array<TypeGroup>;
  deletedComponents: Array<NodeId>;
  deletedRelations: Array<NodeId>;
  deletedIndirectRelations: Array<IndirectRelation>;
  deletedGroups: Array<NodeId>;
  deletedGroupRelations: Array<GroupRelation>;
  metadata: ViewSnapshotMetadata;
  traversalResult: ViewTraversalResult;
}

export const isViewSnapshotDiff = isType<ViewSnapshotDiff>(Type.ViewSnapshotDiff);


export type ViewSnapshotError = ViewSnapshotDataUnavailable | ViewSnapshotFetchTimeout | ViewSnapshotTooManyActiveQueries | ViewSnapshotTopologySizeOverflow;

export function isViewSnapshotError(input: unknown): input is ViewSnapshotError {
  return isViewSnapshotDataUnavailable(input) || isViewSnapshotFetchTimeout(input) || isViewSnapshotTooManyActiveQueries(input) || isViewSnapshotTopologySizeOverflow(input);
}


export interface ViewSnapshotEventsFetchError {
  _type: Type.ViewSnapshotEventsFetchError;
  error: ApiError;
}

export const isViewSnapshotEventsFetchError = isType<ViewSnapshotEventsFetchError>(Type.ViewSnapshotEventsFetchError);


export interface ViewSnapshotEventsOmitted {
  _type: Type.ViewSnapshotEventsOmitted;

}

export const isViewSnapshotEventsOmitted = isType<ViewSnapshotEventsOmitted>(Type.ViewSnapshotEventsOmitted);


export type ViewSnapshotEventsResponseStatus = ViewSnapshotEventsFetchError | ViewSnapshotEventsOmitted | ViewSnapshotEventsSucceeded;

export function isViewSnapshotEventsResponseStatus(input: unknown): input is ViewSnapshotEventsResponseStatus {
  return isViewSnapshotEventsFetchError(input) || isViewSnapshotEventsOmitted(input) || isViewSnapshotEventsSucceeded(input);
}


export interface ViewSnapshotEventsSucceeded {
  _type: Type.ViewSnapshotEventsSucceeded;

}

export const isViewSnapshotEventsSucceeded = isType<ViewSnapshotEventsSucceeded>(Type.ViewSnapshotEventsSucceeded);


export interface ViewSnapshotFetchTimeout {
  _type: Type.ViewSnapshotFetchTimeout;
  usedTimeoutSeconds: number;
}

export const isViewSnapshotFetchTimeout = isType<ViewSnapshotFetchTimeout>(Type.ViewSnapshotFetchTimeout);


export interface ViewSnapshotMetadata {
  _type: Type.ViewSnapshotMetadata;
  componentTypes: Array<ComponentType>;
  relationTypes: Array<RelationType>;
  layers: Array<Layer>;
  domains: Array<Domain>;
  groupedByLayers: boolean;
  groupedByDomains: boolean;
}

export const isViewSnapshotMetadata = isType<ViewSnapshotMetadata>(Type.ViewSnapshotMetadata);


export interface ViewSnapshotRequest {
  _type: Type.ViewSnapshotRequest;
  query: string;
  queryVersion: Version;
  metadata: QueryMetadata;
}

export const isViewSnapshotRequest = isType<ViewSnapshotRequest>(Type.ViewSnapshotRequest);


export type ViewSnapshotResponse = ViewSnapshot | ViewSnapshotError;

export function isViewSnapshotResponse(input: unknown): input is ViewSnapshotResponse {
  return isViewSnapshot(input) || isViewSnapshotError(input);
}


export type ViewSnapshotStreamResponse = ViewSnapshot | ViewSnapshotDiff | ViewSnapshotError;

export function isViewSnapshotStreamResponse(input: unknown): input is ViewSnapshotStreamResponse {
  return isViewSnapshot(input) || isViewSnapshotDiff(input) || isViewSnapshotError(input);
}


export interface ViewSnapshotTooManyActiveQueries {
  _type: Type.ViewSnapshotTooManyActiveQueries;

}

export const isViewSnapshotTooManyActiveQueries = isType<ViewSnapshotTooManyActiveQueries>(Type.ViewSnapshotTooManyActiveQueries);


export interface ViewSnapshotTopologySizeOverflow {
  _type: Type.ViewSnapshotTopologySizeOverflow;
  maxSize: number;
}

export const isViewSnapshotTopologySizeOverflow = isType<ViewSnapshotTopologySizeOverflow>(Type.ViewSnapshotTopologySizeOverflow);


export interface ViewTraversalResult {
  _type: Type.ViewTraversalResult;
  allHiddenPathsTraversed: boolean;
  allConnectedComponentsFound: boolean;
}

export const isViewTraversalResult = isType<ViewTraversalResult>(Type.ViewTraversalResult);


export interface ViewType {
  _type: Type.ViewType;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  overview: ViewTypeOverview;
  flags: Array<ViewTypeFlagValue>;
  filters: Array<ViewTypeFilter>;
  iconbase64?: string;
}

export const isViewType = isType<ViewType>(Type.ViewType);


export interface WebSocketClosed {
  _type: Type.WebSocketClosed;

}

export const isWebSocketClosed = isType<WebSocketClosed>(Type.WebSocketClosed);


export type WebSocketInProtocol = WebSocketClosed | WebSocketStartStream | WebSocketStopStream;

export function isWebSocketInProtocol(input: unknown): input is WebSocketInProtocol {
  return isWebSocketClosed(input) || isWebSocketStartStream(input) || isWebSocketStopStream(input);
}


export type WebSocketOutProtocol = WebSocketStreamResponse;

export function isWebSocketOutProtocol(input: unknown): input is WebSocketOutProtocol {
  return isWebSocketStreamResponse(input);
}


export interface WebSocketStartStream {
  _type: Type.WebSocketStartStream;
  streamType: WebSocketStreamType;
  streamIdentifier: string;
  request?: SocketStreamRequest;
}

export const isWebSocketStartStream = isType<WebSocketStartStream>(Type.WebSocketStartStream);


export interface WebSocketStopStream {
  _type: Type.WebSocketStopStream;
  streamType: WebSocketStreamType;
}

export const isWebSocketStopStream = isType<WebSocketStopStream>(Type.WebSocketStopStream);


export interface WebSocketStreamResponse {
  _type: Type.WebSocketStreamResponse;
  streamType: WebSocketStreamType;
  streamIdentifier: string;
  response: Dto;
}

export const isWebSocketStreamResponse = isType<WebSocketStreamResponse>(Type.WebSocketStreamResponse);

export enum WebSocketStreamType {
  LandscapeHealthState = "LandscapeHealthState",
  ViewSnapshot = "ViewSnapshot",
  GlobalStoreSnapshot = "GlobalStoreSnapshot",
  ViewSnapshotDiffStream = "ViewSnapshotDiffStream",
  KeepAlive = "KeepAlive",
  StatusUpdateStream = "StatusUpdateStream",
  PermissionStream = "PermissionStream",
  StackElementActivitiesStream = "StackElementActivitiesStream",
}


export interface ExecutableComponentAction {
  _type: Type.ExecutableComponentAction;
  script: FunctionBody;
  parameters: Array<Parameter>;
  name: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  component: Component;
}

export const isExecutableComponentAction = isType<ExecutableComponentAction>(Type.ExecutableComponentAction);


export interface ComponentActionDefinition {
  _type: Type.ComponentActionDefinition;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  bindQuery: string;
  script: string;
}

export const isComponentActionDefinition = isType<ComponentActionDefinition>(Type.ComponentActionDefinition);


export interface ComponentLinkDisplay {
  _type: Type.ComponentLinkDisplay;

}

export const isComponentLinkDisplay = isType<ComponentLinkDisplay>(Type.ComponentLinkDisplay);


export interface ComponentTypeAbout {
  _type: Type.ComponentTypeAbout;
  fields: Array<string>;
}

export const isComponentTypeAbout = isType<ComponentTypeAbout>(Type.ComponentTypeAbout);


export interface ComponentTypeEvents {
  _type: Type.ComponentTypeEvents;
  showEvents: boolean;
  relatedResourcesTemplate?: string;
}

export const isComponentTypeEvents = isType<ComponentTypeEvents>(Type.ComponentTypeEvents);


export interface ComponentTypeExternalComponent {
  _type: Type.ComponentTypeExternalComponent;
  showConfiguration: boolean;
  showStatus: boolean;
  externalIdSelector: string;
}

export const isComponentTypeExternalComponent = isType<ComponentTypeExternalComponent>(Type.ComponentTypeExternalComponent);


export interface ComponentTypeField {
  _type: Type.ComponentTypeField;
  fieldId: string;
  label: ComponentTypeLabel;
  valueExtractor: ComponentTypeValueExtractor;
  display: ComponentTypeFieldDisplay;
}

export const isComponentTypeField = isType<ComponentTypeField>(Type.ComponentTypeField);


export type ComponentTypeFieldDisplay = ComponentLinkDisplay | DurationDisplay | HealthBadgeDisplay | HealthCircleDisplay | PromQLDisplay | RatioDisplay | ReadyStatusDisplay | TagDisplay | TextDisplay | ViewTimeLink;

export function isComponentTypeFieldDisplay(input: unknown): input is ComponentTypeFieldDisplay {
  return isComponentLinkDisplay(input) || isDurationDisplay(input) || isHealthBadgeDisplay(input) || isHealthCircleDisplay(input) || isPromQLDisplay(input) || isRatioDisplay(input) || isReadyStatusDisplay(input) || isTagDisplay(input) || isTextDisplay(input) || isViewTimeLink(input);
}


export interface ComponentTypeLabel {
  _type: Type.ComponentTypeLabel;
  title: string;
  helpBubbleText?: string;
}

export const isComponentTypeLabel = isType<ComponentTypeLabel>(Type.ComponentTypeLabel);


export interface ComponentTypeMetricCategory {
  _type: Type.ComponentTypeMetricCategory;
  name: string;
  description?: string;
  bindings: Array<string>;
  defaultExpanded: boolean;
}

export const isComponentTypeMetricCategory = isType<ComponentTypeMetricCategory>(Type.ComponentTypeMetricCategory);


export interface ComponentTypeRelatedResources {
  _type: Type.ComponentTypeRelatedResources;
  resourceType: string;
  title: string;
  stql: string;
  hint?: string;
  viewTypeIdentifier?: string;
}

export const isComponentTypeRelatedResources = isType<ComponentTypeRelatedResources>(Type.ComponentTypeRelatedResources);


export interface ComponentTypeSource {
  _type: Type.ComponentTypeSource;

}

export const isComponentTypeSource = isType<ComponentTypeSource>(Type.ComponentTypeSource);


export type ComponentTypeValueExtractor = ComponentTypeSource | CompositeSource | ConstantSource | HealthSource | IdentifiersSource | LastUpdatedTimestampSource | NameSource | PropertySource | TagSource | TagsSource;

export function isComponentTypeValueExtractor(input: unknown): input is ComponentTypeValueExtractor {
  return isComponentTypeSource(input) || isCompositeSource(input) || isConstantSource(input) || isHealthSource(input) || isIdentifiersSource(input) || isLastUpdatedTimestampSource(input) || isNameSource(input) || isPropertySource(input) || isTagSource(input) || isTagsSource(input);
}


export interface CompositeSource {
  _type: Type.CompositeSource;
  sources: Record<string, ComponentTypeValueExtractor>;
}

export const isCompositeSource = isType<CompositeSource>(Type.CompositeSource);


export interface ConstantSource {
  _type: Type.ConstantSource;
  value: string;
}

export const isConstantSource = isType<ConstantSource>(Type.ConstantSource);


export interface DurationDisplay {
  _type: Type.DurationDisplay;

}

export const isDurationDisplay = isType<DurationDisplay>(Type.DurationDisplay);


export interface HealthBadgeDisplay {
  _type: Type.HealthBadgeDisplay;

}

export const isHealthBadgeDisplay = isType<HealthBadgeDisplay>(Type.HealthBadgeDisplay);


export interface HealthCircleDisplay {
  _type: Type.HealthCircleDisplay;

}

export const isHealthCircleDisplay = isType<HealthCircleDisplay>(Type.HealthCircleDisplay);


export interface HealthSource {
  _type: Type.HealthSource;

}

export const isHealthSource = isType<HealthSource>(Type.HealthSource);


export interface IdentifiersSource {
  _type: Type.IdentifiersSource;

}

export const isIdentifiersSource = isType<IdentifiersSource>(Type.IdentifiersSource);


export interface LastUpdatedTimestampSource {
  _type: Type.LastUpdatedTimestampSource;

}

export const isLastUpdatedTimestampSource = isType<LastUpdatedTimestampSource>(Type.LastUpdatedTimestampSource);


export interface NameSource {
  _type: Type.NameSource;

}

export const isNameSource = isType<NameSource>(Type.NameSource);


export interface PromQLDisplay {
  _type: Type.PromQLDisplay;

}

export const isPromQLDisplay = isType<PromQLDisplay>(Type.PromQLDisplay);


export interface PropertySource {
  _type: Type.PropertySource;
  key: string;
  defaultValue?: string;
}

export const isPropertySource = isType<PropertySource>(Type.PropertySource);


export interface RatioDisplay {
  _type: Type.RatioDisplay;

}

export const isRatioDisplay = isType<RatioDisplay>(Type.RatioDisplay);


export interface ReadyStatusDisplay {
  _type: Type.ReadyStatusDisplay;

}

export const isReadyStatusDisplay = isType<ReadyStatusDisplay>(Type.ReadyStatusDisplay);


export interface TagDisplay {
  _type: Type.TagDisplay;
  singular?: string;
}

export const isTagDisplay = isType<TagDisplay>(Type.TagDisplay);


export interface TagSource {
  _type: Type.TagSource;
  tagName: string;
}

export const isTagSource = isType<TagSource>(Type.TagSource);


export interface TagsSource {
  _type: Type.TagsSource;

}

export const isTagsSource = isType<TagsSource>(Type.TagsSource);


export interface TextDisplay {
  _type: Type.TextDisplay;

}

export const isTextDisplay = isType<TextDisplay>(Type.TextDisplay);


export interface ViewTimeLink {
  _type: Type.ViewTimeLink;

}

export const isViewTimeLink = isType<ViewTimeLink>(Type.ViewTimeLink);


export interface ActionExecutionRequest {
  _type: Type.ActionExecutionRequest;
  actionId: number;
  timeContext: ActionExecutionTimeContext;
}

export const isActionExecutionRequest = isType<ActionExecutionRequest>(Type.ActionExecutionRequest);


export interface ActionExecutionTimeContext {
  _type: Type.ActionExecutionTimeContext;
  topologyTime?: number;
  telemetryTimeStart: number;
  telemetryTimeEnd?: number;
}

export const isActionExecutionTimeContext = isType<ActionExecutionTimeContext>(Type.ActionExecutionTimeContext);


export interface ComponentAction {
  _type: Type.ComponentAction;
  id: number;
  name: string;
  description?: string;
}

export const isComponentAction = isType<ComponentAction>(Type.ComponentAction);


export interface PreviewComponent {
  _type: Type.PreviewComponent;
  id: number;
  name: string;
  type: string;
  tags: Array<string>;
  properties: Record<string, string>;
  identifiers: Array<string>;
}

export const isPreviewComponent = isType<PreviewComponent>(Type.PreviewComponent);


export interface Dashboard {
  _type: Type.Dashboard;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  dashboard: Record<string, unknown>;
}

export const isDashboard = isType<Dashboard>(Type.Dashboard);


export interface DashboardBackup {
  _type: Type.DashboardBackup;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  dashboardScope: DashboardScope;
  dashboard: Record<string, unknown>;
  owner?: NodeId;
}

export const isDashboardBackup = isType<DashboardBackup>(Type.DashboardBackup);


export interface StsTopologyElementsQuery {
  _type: Type.StsTopologyElementsQuery;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  componentIdExtractorFunction: NodeId;
  relationIdExtractorFunction: NodeId;
}

export const isStsTopologyElementsQuery = isType<StsTopologyElementsQuery>(Type.StsTopologyElementsQuery);

export enum Category {
  Changes = "Changes",
  Deployments = "Deployments",
  Anomalies = "Anomalies",
  Activities = "Activities",
  Alerts = "Alerts",
  Others = "Others",
}


export interface Activities {
  _type: Type.Activities;

}

export const isActivities = isType<Activities>(Type.Activities);


export interface Alerts {
  _type: Type.Alerts;

}

export const isAlerts = isType<Alerts>(Type.Alerts);


export interface Anomalies {
  _type: Type.Anomalies;

}

export const isAnomalies = isType<Anomalies>(Type.Anomalies);


export interface Changes {
  _type: Type.Changes;

}

export const isChanges = isType<Changes>(Type.Changes);


export interface Deployments {
  _type: Type.Deployments;

}

export const isDeployments = isType<Deployments>(Type.Deployments);


export interface Others {
  _type: Type.Others;

}

export const isOthers = isType<Others>(Type.Others);


export interface EventComponent {
  _type: Type.EventComponent;
  id: number;
  name: string;
  type: string;
  identifiers: Array<string>;
  icon?: string;
}

export const isEventComponent = isType<EventComponent>(Type.EventComponent);


export type EventElement = EventComponent | EventRelation;

export function isEventElement(input: unknown): input is EventElement {
  return isEventComponent(input) || isEventRelation(input);
}


export interface EventRelation {
  _type: Type.EventRelation;
  id: number;
  name?: string;
  type: string;
  identifiers: Array<string>;
  source: EventComponent;
  target: EventComponent;
  dependencyDirection: DependencyDirection;
}

export const isEventRelation = isType<EventRelation>(Type.EventRelation);


export interface EventTag {
  _type: Type.EventTag;
  key: string;
  value: string;
}

export const isEventTag = isType<EventTag>(Type.EventTag);


export interface SourceLink {
  _type: Type.SourceLink;
  title: string;
  url: string;
}

export const isSourceLink = isType<SourceLink>(Type.SourceLink);


export interface TopologyEvent {
  _type: Type.TopologyEvent;
  identifier: string;
  sourceIdentifier?: string;
  elementIdentifiers: Array<string>;
  elements: Array<EventElement>;
  source: string;
  category: Category;
  description?: string;
  name: string;
  sourceLinks: Array<SourceLink>;
  data: Record<string, unknown>;
  eventType: string;
  eventTime: number;
  processedTime: number;
  tags: Array<EventTag>;
}

export const isTopologyEvent = isType<TopologyEvent>(Type.TopologyEvent);

export enum TopologyEventType {
  ConfigurationChangedEventType = "Configuration Changed",
  VersionChangedEventType = "Version Changed",
  RunStateChangedEventType = "Run State Changed",
  HealthStateChangedEventType = "Health State Changed",
  ElementDeletedEventType = "Element Deleted",
  ElementUpdatedEventType = "Element Updated",
  ElementCreatedEventType = "Element Created",
  MetricStreamAnomalyEventType = "Metric Stream Anomaly",
}


export interface ConfigurationChangedEventType {
  _type: Type.ConfigurationChangedEventType;

}

export const isConfigurationChangedEventType = isType<ConfigurationChangedEventType>(Type.ConfigurationChangedEventType);


export interface ElementCreatedEventType {
  _type: Type.ElementCreatedEventType;

}

export const isElementCreatedEventType = isType<ElementCreatedEventType>(Type.ElementCreatedEventType);


export interface ElementDeletedEventType {
  _type: Type.ElementDeletedEventType;

}

export const isElementDeletedEventType = isType<ElementDeletedEventType>(Type.ElementDeletedEventType);


export interface ElementUpdatedEventType {
  _type: Type.ElementUpdatedEventType;

}

export const isElementUpdatedEventType = isType<ElementUpdatedEventType>(Type.ElementUpdatedEventType);


export interface HealthStateChangedEventType {
  _type: Type.HealthStateChangedEventType;

}

export const isHealthStateChangedEventType = isType<HealthStateChangedEventType>(Type.HealthStateChangedEventType);


export interface MetricStreamAnomalyEventType {
  _type: Type.MetricStreamAnomalyEventType;

}

export const isMetricStreamAnomalyEventType = isType<MetricStreamAnomalyEventType>(Type.MetricStreamAnomalyEventType);


export interface RunStateChangedEventType {
  _type: Type.RunStateChangedEventType;

}

export const isRunStateChangedEventType = isType<RunStateChangedEventType>(Type.RunStateChangedEventType);


export interface VersionChangedEventType {
  _type: Type.VersionChangedEventType;

}

export const isVersionChangedEventType = isType<VersionChangedEventType>(Type.VersionChangedEventType);


export interface HealthSyncError {
  _type: Type.HealthSyncError;
  message: string;
  detailedMessage: string;
  errorState: HealthSyncErrorState;
}

export const isHealthSyncError = isType<HealthSyncError>(Type.HealthSyncError);


export interface HealthSyncStream {
  _type: Type.HealthSyncStream;
  id: NodeId;
  lastUpdateTimestamp: number;
  partition: number;
  owner: string;
  streamIdentifier: string;
  metaData: HealthSyncStreamMetaData;
  settings: Record<string, unknown>;
}

export const isHealthSyncStream = isType<HealthSyncStream>(Type.HealthSyncStream);


export type HealthSyncStreamMetaData = HealthTransformerMetaData | MonitorMetaData;

export function isHealthSyncStreamMetaData(input: unknown): input is HealthSyncStreamMetaData {
  return isHealthTransformerMetaData(input) || isMonitorMetaData(input);
}


export interface HealthSyncSubStream {
  _type: Type.HealthSyncSubStream;
  id: NodeId;
  lastUpdateTimestamp: number;
  subStreamId?: string;
  subStreamState: HealthSyncSubStreamConsistencyState;
  activeErrors: Array<HealthSyncError>;
  stream: HealthSyncStream;
}

export const isHealthSyncSubStream = isType<HealthSyncSubStream>(Type.HealthSyncSubStream);


export interface HealthTransformerMetaData {
  _type: Type.HealthTransformerMetaData;
  source: string;
  streamId: string;
}

export const isHealthTransformerMetaData = isType<HealthTransformerMetaData>(Type.HealthTransformerMetaData);


export interface MonitorMetaData {
  _type: Type.MonitorMetaData;
  vertexId: number;
}

export const isMonitorMetaData = isType<MonitorMetaData>(Type.MonitorMetaData);


export interface MonitorSyncedCheckStateData {
  _type: Type.MonitorSyncedCheckStateData;
  displayTimeSeries: Array<MonitorDisplayTimeSeries>;
  remediationHint?: string;
}

export const isMonitorSyncedCheckStateData = isType<MonitorSyncedCheckStateData>(Type.MonitorSyncedCheckStateData);


export interface SyncedCheckState {
  _type: Type.SyncedCheckState;
  id: NodeId;
  lastUpdateTimestamp: number;
  checkStateId: string;
  name: string;
  topologyElementIdentifier: string;
  health: HealthStateValue;
  message?: string;
  data?: MonitorSyncedCheckStateData;
  subStream: HealthSyncSubStream;
  triggeredTimestamp?: number;
}

export const isSyncedCheckState = isType<SyncedCheckState>(Type.SyncedCheckState);


export interface MonitorDisplayQuery {
  _type: Type.MonitorDisplayQuery;
  query: string;
  alias?: string;
  componentIdentifierTemplate?: string;
}

export const isMonitorDisplayQuery = isType<MonitorDisplayQuery>(Type.MonitorDisplayQuery);


export interface MonitorDisplayTimeSeries {
  _type: Type.MonitorDisplayTimeSeries;
  name: string;
  queries: Array<MonitorDisplayQuery>;
  description?: string;
  unit?: string;
}

export const isMonitorDisplayTimeSeries = isType<MonitorDisplayTimeSeries>(Type.MonitorDisplayTimeSeries);


export interface TriggerOnTemplate {
  _type: Type.TriggerOnTemplate;
  parts: Array<TriggerOnPart>;
}

export const isTriggerOnTemplate = isType<TriggerOnTemplate>(Type.TriggerOnTemplate);


export interface TriggerOnParameter {
  _type: Type.TriggerOnParameter;
  name: string;
  display?: string;
}

export const isTriggerOnParameter = isType<TriggerOnParameter>(Type.TriggerOnParameter);


export type TriggerOnPart = TriggerOnParameter | TriggerOnText;

export function isTriggerOnPart(input: unknown): input is TriggerOnPart {
  return isTriggerOnParameter(input) || isTriggerOnText(input);
}


export interface TriggerOnText {
  _type: Type.TriggerOnText;
  text: string;
}

export const isTriggerOnText = isType<TriggerOnText>(Type.TriggerOnText);


export type HealthSyncSubStreamConsistencyState = HealthSyncSubStreamExpiry | HealthSyncSubStreamSnapshot | HealthSyncSubStreamTransactionalIncrements;

export function isHealthSyncSubStreamConsistencyState(input: unknown): input is HealthSyncSubStreamConsistencyState {
  return isHealthSyncSubStreamExpiry(input) || isHealthSyncSubStreamSnapshot(input) || isHealthSyncSubStreamTransactionalIncrements(input);
}


export interface HealthSyncSubStreamExpiry {
  _type: Type.HealthSyncSubStreamExpiry;
  expiryIntervalMs: number;
  repeatIntervalMs: number;
}

export const isHealthSyncSubStreamExpiry = isType<HealthSyncSubStreamExpiry>(Type.HealthSyncSubStreamExpiry);


export interface HealthSyncSubStreamSnapshot {
  _type: Type.HealthSyncSubStreamSnapshot;
  expiryIntervalMs?: number;
  repeatIntervalMs: number;
}

export const isHealthSyncSubStreamSnapshot = isType<HealthSyncSubStreamSnapshot>(Type.HealthSyncSubStreamSnapshot);


export interface HealthSyncSubStreamTransactionalIncrements {
  _type: Type.HealthSyncSubStreamTransactionalIncrements;
  offset: number;
  batchIndex?: number;
}

export const isHealthSyncSubStreamTransactionalIncrements = isType<HealthSyncSubStreamTransactionalIncrements>(Type.HealthSyncSubStreamTransactionalIncrements);


export interface Append {
  _type: Type.Append;

}

export const isAppend = isType<Append>(Type.Append);


export interface Increment {
  _type: Type.Increment;

}

export const isIncrement = isType<Increment>(Type.Increment);


export interface Remove {
  _type: Type.Remove;

}

export const isRemove = isType<Remove>(Type.Remove);


export interface Set {
  _type: Type.Set;

}

export const isSet = isType<Set>(Type.Set);


export interface ApiLimitReached {
  _type: Type.ApiLimitReached;

}

export const isApiLimitReached = isType<ApiLimitReached>(Type.ApiLimitReached);


export interface BooleanTrackingParameter {
  _type: Type.BooleanTrackingParameter;
  name: string;
  mode: Mode;
  value: boolean;
}

export const isBooleanTrackingParameter = isType<BooleanTrackingParameter>(Type.BooleanTrackingParameter);


export interface Contact {
  _type: Type.Contact;
  vid: number;
  properties: Record<string, ContactProperty>;
}

export const isContact = isType<Contact>(Type.Contact);


export interface ContactProperty {
  _type: Type.ContactProperty;
  name: string;
  value: string;
}

export const isContactProperty = isType<ContactProperty>(Type.ContactProperty);


export interface HubSpotApiError {
  _type: Type.HubSpotApiError;

}

export const isHubSpotApiError = isType<HubSpotApiError>(Type.HubSpotApiError);


export type HubSpotError = ApiLimitReached | HubSpotApiError | InvalidPropertyValue | PropertyDoesNotExist;

export function isHubSpotError(input: unknown): input is HubSpotError {
  return isApiLimitReached(input) || isHubSpotApiError(input) || isInvalidPropertyValue(input) || isPropertyDoesNotExist(input);
}


export interface InvalidPropertyValue {
  _type: Type.InvalidPropertyValue;
  propertyName: string;
  message: string;
}

export const isInvalidPropertyValue = isType<InvalidPropertyValue>(Type.InvalidPropertyValue);


export interface ListTrackingParameter {
  _type: Type.ListTrackingParameter;
  name: string;
  mode: Mode;
  value: Array<string>;
}

export const isListTrackingParameter = isType<ListTrackingParameter>(Type.ListTrackingParameter);

export enum Mode {
  Set = "set",
  Increment = "increment",
  Append = "append",
  Remove = "remove",
}


export interface NumericTrackingParameter {
  _type: Type.NumericTrackingParameter;
  name: string;
  mode: Mode;
  value: number;
}

export const isNumericTrackingParameter = isType<NumericTrackingParameter>(Type.NumericTrackingParameter);


export interface PropertyDoesNotExist {
  _type: Type.PropertyDoesNotExist;
  propertyName: string;
}

export const isPropertyDoesNotExist = isType<PropertyDoesNotExist>(Type.PropertyDoesNotExist);


export interface SetTrackingParameter {
  _type: Type.SetTrackingParameter;
  name: string;
  mode: Mode;
  value: Array<string>;
}

export const isSetTrackingParameter = isType<SetTrackingParameter>(Type.SetTrackingParameter);


export interface StringTrackingParameter {
  _type: Type.StringTrackingParameter;
  name: string;
  mode: Mode;
  value: string;
}

export const isStringTrackingParameter = isType<StringTrackingParameter>(Type.StringTrackingParameter);


export interface TimestampTrackingParameter {
  _type: Type.TimestampTrackingParameter;
  name: string;
  mode: Mode;
  value: number;
}

export const isTimestampTrackingParameter = isType<TimestampTrackingParameter>(Type.TimestampTrackingParameter);


export interface TrackingError {
  _type: Type.TrackingError;
  hubSpotError: HubSpotError;
}

export const isTrackingError = isType<TrackingError>(Type.TrackingError);


export type TrackingParameter = BooleanTrackingParameter | ListTrackingParameter | NumericTrackingParameter | SetTrackingParameter | StringTrackingParameter | TimestampTrackingParameter;

export function isTrackingParameter(input: unknown): input is TrackingParameter {
  return isBooleanTrackingParameter(input) || isListTrackingParameter(input) || isNumericTrackingParameter(input) || isSetTrackingParameter(input) || isStringTrackingParameter(input) || isTimestampTrackingParameter(input);
}


export type TrackingResponse = TrackingError | TrackingSuccess;

export function isTrackingResponse(input: unknown): input is TrackingResponse {
  return isTrackingError(input) || isTrackingSuccess(input);
}


export interface TrackingSuccess {
  _type: Type.TrackingSuccess;

}

export const isTrackingSuccess = isType<TrackingSuccess>(Type.TrackingSuccess);


export interface ComponentHighlightMetricSection {
  _type: Type.ComponentHighlightMetricSection;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  weight: number;
}

export const isComponentHighlightMetricSection = isType<ComponentHighlightMetricSection>(Type.ComponentHighlightMetricSection);


export interface MetricPerspectiveSection {
  _type: Type.MetricPerspectiveSection;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  tab: string;
  weight: number;
}

export const isMetricPerspectiveSection = isType<MetricPerspectiveSection>(Type.MetricPerspectiveSection);


export interface MetricPerspectiveTab {
  _type: Type.MetricPerspectiveTab;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  weight: number;
}

export const isMetricPerspectiveTab = isType<MetricPerspectiveTab>(Type.MetricPerspectiveTab);


export interface MainMenuGroup {
  _type: Type.MainMenuGroup;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  defaultOpen: boolean;
  iconbase64: string;
  items: Array<MainMenuViewItem>;
  order?: number;
}

export const isMainMenuGroup = isType<MainMenuGroup>(Type.MainMenuGroup);


export interface MainMenuViewItem {
  _type: Type.MainMenuViewItem;
  viewIdentifier: string;
}

export const isMainMenuViewItem = isType<MainMenuViewItem>(Type.MainMenuViewItem);


export interface OtelComponentMapping {
  _type: Type.OtelComponentMapping;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  input: OtelInput;
  output: OtelComponentMappingOutput;
  vars?: Array<OtelVariableMapping>;
  expireAfter: number;
}

export const isOtelComponentMapping = isType<OtelComponentMapping>(Type.OtelComponentMapping);


export interface OtelRelationMapping {
  _type: Type.OtelRelationMapping;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  input: OtelInput;
  output: OtelRelationMappingOutput;
  vars?: Array<OtelVariableMapping>;
  expireAfter: number;
}

export const isOtelRelationMapping = isType<OtelRelationMapping>(Type.OtelRelationMapping);


export type AbstractDisplayTimeSeries = DisplayTimeSeries | MultiDisplayTimeSeries;

export function isAbstractDisplayTimeSeries(input: unknown): input is AbstractDisplayTimeSeries {
  return isDisplayTimeSeries(input) || isMultiDisplayTimeSeries(input);
}


export interface DisplayQuery {
  _type: Type.DisplayQuery;
  query: string;
  alias?: string;
  componentIdentifierTemplate?: string;
}

export const isDisplayQuery = isType<DisplayQuery>(Type.DisplayQuery);


export interface DisplayTimeSeries {
  _type: Type.DisplayTimeSeries;
  name: string;
  timeSeriesId: TimeSeriesId;
  query: PromQLMetricQuery;
}

export const isDisplayTimeSeries = isType<DisplayTimeSeries>(Type.DisplayTimeSeries);


export interface GroovyScript {
  _type: Type.GroovyScript;
  arguments?: string;
  body: string;
}

export const isGroovyScript = isType<GroovyScript>(Type.GroovyScript);


export interface HandlebarsScript {
  _type: Type.HandlebarsScript;
  arguments?: string;
  body: string;
}

export const isHandlebarsScript = isType<HandlebarsScript>(Type.HandlebarsScript);


export interface HealthStateData {
  _type: Type.HealthStateData;
  healthState: HealthStateValue;
}

export const isHealthStateData = isType<HealthStateData>(Type.HealthStateData);

export enum HTTPProtocol {
  HTTP_1_0 = "HTTP_1_0",
  HTTP_1_1 = "HTTP_1_1",
  HTTP_2_0 = "HTTP_2_0",
}


export interface HTTPScriptApiJsonResponse {
  _type: Type.HTTPScriptApiJsonResponse;
  status: number;
  isSuccess: boolean;
  reason: string;
  defaultMessage: string;
  headers: Record<string, string>;
  body?: Record<string, unknown>;
}

export const isHTTPScriptApiJsonResponse = isType<HTTPScriptApiJsonResponse>(Type.HTTPScriptApiJsonResponse);


export interface HTTPScriptApiRequest {
  _type: Type.HTTPScriptApiRequest;
  method: string;
  uri: string;
  timeout: number;
  protocol: HTTPProtocol;
  useProxy: boolean;
  contentType?: string;
  headers?: Record<string, string>;
  queryParams?: Record<string, string>;
  body?: string;
}

export const isHTTPScriptApiRequest = isType<HTTPScriptApiRequest>(Type.HTTPScriptApiRequest);


export type HTTPScriptApiResponse = HTTPScriptApiJsonResponse | HTTPScriptApiTextResponse;

export function isHTTPScriptApiResponse(input: unknown): input is HTTPScriptApiResponse {
  return isHTTPScriptApiJsonResponse(input) || isHTTPScriptApiTextResponse(input);
}


export interface HTTPScriptApiTextResponse {
  _type: Type.HTTPScriptApiTextResponse;
  status: number;
  isSuccess: boolean;
  reason: string;
  defaultMessage: string;
  headers: Record<string, string>;
  body?: string;
}

export const isHTTPScriptApiTextResponse = isType<HTTPScriptApiTextResponse>(Type.HTTPScriptApiTextResponse);


export type MetricQuery = PromQLMetricQueryBase;

export function isMetricQuery(input: unknown): input is MetricQuery {
  return isPromQLMetricQueryBase(input);
}


export interface MetricTimeSeriesResult {
  _type: Type.MetricTimeSeriesResult;
  context: Record<string, string>;
  query: MetricQuery;
  timeSeries: TimeSeries;
}

export const isMetricTimeSeriesResult = isType<MetricTimeSeriesResult>(Type.MetricTimeSeriesResult);


export interface MonitorCompletesAsynchronously {
  _type: Type.MonitorCompletesAsynchronously;

}

export const isMonitorCompletesAsynchronously = isType<MonitorCompletesAsynchronously>(Type.MonitorCompletesAsynchronously);


export interface MonitorHealthState {
  _type: Type.MonitorHealthState;
  id: string;
  state: HealthStateValue;
  topologyIdentifier: string;
  displayTimeSeries?: Array<AbstractDisplayTimeSeries>;
  title?: string;
  remediationHintTemplateData?: Record<string, unknown>;
  message?: string;
  reason?: string;
}

export const isMonitorHealthState = isType<MonitorHealthState>(Type.MonitorHealthState);


export interface MonitorIncompleteHealthState {
  _type: Type.MonitorIncompleteHealthState;
  id: string;
  message: string;
}

export const isMonitorIncompleteHealthState = isType<MonitorIncompleteHealthState>(Type.MonitorIncompleteHealthState);


export type MonitorResult = MonitorCompletesAsynchronously | MonitorHealthState | MonitorIncompleteHealthState;

export function isMonitorResult(input: unknown): input is MonitorResult {
  return isMonitorCompletesAsynchronously(input) || isMonitorHealthState(input) || isMonitorIncompleteHealthState(input);
}


export interface MultiDisplayTimeSeries {
  _type: Type.MultiDisplayTimeSeries;
  name: string;
  timeSeriesId: TimeSeriesId;
  queries: Array<DisplayQuery>;
  description?: string;
  unit?: string;
}

export const isMultiDisplayTimeSeries = isType<MultiDisplayTimeSeries>(Type.MultiDisplayTimeSeries);


export interface PromQLInstantMetricQuery {
  _type: Type.PromQLInstantMetricQuery;
  query: string;
  alias?: string;
  description?: string;
  unit?: string;
  queryTime?: number;
}

export const isPromQLInstantMetricQuery = isType<PromQLInstantMetricQuery>(Type.PromQLInstantMetricQuery);


export interface PromQLMetricQuery {
  _type: Type.PromQLMetricQuery;
  query: string;
  alias?: string;
  description?: string;
  unit?: string;
  startTime?: number;
  endTime?: number;
  step?: number;
  componentIdentifierTemplate?: string;
}

export const isPromQLMetricQuery = isType<PromQLMetricQuery>(Type.PromQLMetricQuery);


export type PromQLMetricQueryBase = PromQLInstantMetricQuery | PromQLMetricQuery;

export function isPromQLMetricQueryBase(input: unknown): input is PromQLMetricQueryBase {
  return isPromQLInstantMetricQuery(input) || isPromQLMetricQuery(input);
}


export interface QueryViewResponse {
  _type: Type.QueryViewResponse;
  view: QueryView;
  viewInfo: ViewInfo;
}

export const isQueryViewResponse = isType<QueryViewResponse>(Type.QueryViewResponse);


export interface StarCount {
  _type: Type.StarCount;
  count: number;
}

export const isStarCount = isType<StarCount>(Type.StarCount);


export interface ViewInfo {
  _type: Type.ViewInfo;
  stars?: StarCount;
}

export const isViewInfo = isType<ViewInfo>(Type.ViewInfo);


export interface ScriptApiComponent {
  _type: Type.ScriptApiComponent;
  id?: NodeId;
  name: string;
  identifiers?: Array<string>;
  tags?: Array<string>;
  properties?: Record<string, string>;
  synchronizationData?: Record<string, Array<SynchronizationData>>;
  healthStateData?: HealthStateData;
}

export const isScriptApiComponent = isType<ScriptApiComponent>(Type.ScriptApiComponent);


export interface ShowStmlReport {
  _type: Type.ShowStmlReport;
  reportName: string;
  stmlContent: string;
  data?: Record<string, unknown>;
}

export const isShowStmlReport = isType<ShowStmlReport>(Type.ShowStmlReport);


export interface ShowTopologyByQuery {
  _type: Type.ShowTopologyByQuery;
  query: string;
}

export const isShowTopologyByQuery = isType<ShowTopologyByQuery>(Type.ShowTopologyByQuery);


export interface SynchronizationData {
  _type: Type.SynchronizationData;
  data: Record<string, unknown>;
  sourceProperties?: Record<string, unknown>;
  status?: Record<string, unknown>;
}

export const isSynchronizationData = isType<SynchronizationData>(Type.SynchronizationData);


export interface TopologyScriptApiQuery {
  _type: Type.TopologyScriptApiQuery;
  query: string;
  at?: number;
}

export const isTopologyScriptApiQuery = isType<TopologyScriptApiQuery>(Type.TopologyScriptApiQuery);


export interface TopologyScriptApiQueryDiff {
  _type: Type.TopologyScriptApiQueryDiff;
  queryA: TopologyScriptApiQuery;
  queryB: TopologyScriptApiQuery;
  result: ViewSnapshotDiff;
}

export const isTopologyScriptApiQueryDiff = isType<TopologyScriptApiQueryDiff>(Type.TopologyScriptApiQueryDiff);


export interface TopologyScriptApiQueryResponse {
  _type: Type.TopologyScriptApiQueryResponse;
  queryResults?: Array<TopologyScriptApiQueryResult>;
  diffResults?: Array<TopologyScriptApiQueryDiff>;
}

export const isTopologyScriptApiQueryResponse = isType<TopologyScriptApiQueryResponse>(Type.TopologyScriptApiQueryResponse);


export interface TopologyScriptApiQueryResult {
  _type: Type.TopologyScriptApiQueryResult;
  query: TopologyScriptApiQuery;
  result: ViewSnapshot;
}

export const isTopologyScriptApiQueryResult = isType<TopologyScriptApiQueryResult>(Type.TopologyScriptApiQueryResult);


export type UIAction = ShowStmlReport | ShowTopologyByQuery | URLRedirectResponse;

export function isUIAction(input: unknown): input is UIAction {
  return isShowStmlReport(input) || isShowTopologyByQuery(input) || isURLRedirectResponse(input);
}


export interface URLRedirectResponse {
  _type: Type.URLRedirectResponse;
  url: string;
  newTab: boolean;
}

export const isURLRedirectResponse = isType<URLRedirectResponse>(Type.URLRedirectResponse);


export type UserScript = GroovyScript | HandlebarsScript;

export function isUserScript(input: unknown): input is UserScript {
  return isGroovyScript(input) || isHandlebarsScript(input);
}


export type ObservabilityPermission = ResourcePermission | SystemPermission;

export function isObservabilityPermission(input: unknown): input is ObservabilityPermission {
  return isResourcePermission(input) || isSystemPermission(input);
}


export interface ObservabilitySubject {
  _type: Type.ObservabilitySubject;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  permissions: Array<ObservabilityPermission>;
  query?: string;
  handle: string;
}

export const isObservabilitySubject = isType<ObservabilitySubject>(Type.ObservabilitySubject);


export interface ResourcePermission {
  _type: Type.ResourcePermission;
  value: PermissionValue;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  resourceName: string;
}

export const isResourcePermission = isType<ResourcePermission>(Type.ResourcePermission);


export interface SystemPermission {
  _type: Type.SystemPermission;
  value: PermissionValue;
  id?: NodeId;
  lastUpdateTimestamp?: number;
}

export const isSystemPermission = isType<SystemPermission>(Type.SystemPermission);


export interface DeleteVersionsResult {
  _type: Type.DeleteVersionsResult;
  deleted: Array<string>;
  skippedInUse: Array<string>;
}

export const isDeleteVersionsResult = isType<DeleteVersionsResult>(Type.DeleteVersionsResult);


export interface FAQ {
  _type: Type.FAQ;
  question: string;
  answer: string;
}

export const isFAQ = isType<FAQ>(Type.FAQ);


export interface FullStackPack {
  _type: Type.FullStackPack;
  name: string;
  displayName: string;
  version: string;
  logo?: string;
  categories: Array<string>;
  overviewUrl?: string;
  detailedOverviewUrl?: string;
  resourcesUrl?: string;
  faqs: Array<FAQ>;
  configurationUrls: Array<[StackPackInstanceState,string]>;
  releaseStatus: StackPackStatus;
  isCompatible: boolean;
  isMultiConfig: boolean;
  steps: Array<Step>;
  integrations: Array<StackPackIntegration>;
  releaseNotes?: string;
  upgradeInstructions?: string;
  configurations: Array<StackPackConfiguration>;
  nextVersion?: FullStackPack;
  latestVersion?: FullStackPack;
  canUninstall: boolean;
  defaultNameConfigKey?: string;
}

export const isFullStackPack = isType<FullStackPack>(Type.FullStackPack);


export interface LightStackPack {
  _type: Type.LightStackPack;
  name: string;
  displayName: string;
  version: string;
  logo?: string;
  categories: Array<string>;
  overviewUrl?: string;
  detailedOverviewUrl?: string;
  resourcesUrl?: string;
  faqs: Array<FAQ>;
  configurationUrls: Array<[StackPackInstanceState,string]>;
  releaseStatus: StackPackStatus;
  isCompatible: boolean;
  configuration?: StackPackConfiguration;
}

export const isLightStackPack = isType<LightStackPack>(Type.LightStackPack);


export type StackPack = FullStackPack | LightStackPack;

export function isStackPack(input: unknown): input is StackPack {
  return isFullStackPack(input) || isLightStackPack(input);
}


export interface StackPackConfiguration {
  _type: Type.StackPackConfiguration;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  status: StackPackInstanceState;
  error?: StackPackError;
  stackPackVersion: string;
  config: Record<string, unknown>;
}

export const isStackPackConfiguration = isType<StackPackConfiguration>(Type.StackPackConfiguration);


export interface StackPackError {
  _type: Type.StackPackError;
  retryable: boolean;
  action?: StackPackAction;
  error: ApiError;
}

export const isStackPackError = isType<StackPackError>(Type.StackPackError);


export interface StackPackIntegration {
  _type: Type.StackPackIntegration;
  name: string;
  displayName: string;
  logo?: string;
  brandIcon?: string;
  categories: Array<string>;
  overviewUrl?: string;
  resourceUrl?: string;
  faqs: Array<FAQ>;
}

export const isStackPackIntegration = isType<StackPackIntegration>(Type.StackPackIntegration);


export interface StackPackVersionInfo {
  _type: Type.StackPackVersionInfo;
  version: string;
  isDev: boolean;
  isInUse: boolean;
}

export const isStackPackVersionInfo = isType<StackPackVersionInfo>(Type.StackPackVersionInfo);


export interface Step {
  _type: Type.Step;
  name: string;
  display: string;
  value: StepType;
}

export const isStep = isType<Step>(Type.Step);


export type StepType = Password | Text;

export function isStepType(input: unknown): input is StepType {
  return isPassword(input) || isText(input);
}


export interface Password {
  _type: Type.Password;

}

export const isPassword = isType<Password>(Type.Password);


export interface Text {
  _type: Type.Text;
  default?: string;
}

export const isText = isType<Text>(Type.Text);


export interface BoundMetric {
  _type: Type.BoundMetric;
  name: string;
  identifier?: string;
  boundQueries: Array<BoundMetricQuery>;
  description?: string;
  unit?: string;
  chartType: ChartType;
  alias?: string;
  valuation?: MetricValuation;
  tags?: Record<string, string>;
  layout?: MetricBindingLayout;
  dummy?: boolean;
}

export const isBoundMetric = isType<BoundMetric>(Type.BoundMetric);


export interface BoundMetricQuery {
  _type: Type.BoundMetricQuery;
  expression: string;
  alias: string;
  componentIdentifierTemplate?: string;
  primary?: boolean;
}

export const isBoundMetricQuery = isType<BoundMetricQuery>(Type.BoundMetricQuery);


export interface BoundMetrics {
  _type: Type.BoundMetrics;
  boundMetrics: Array<BoundMetric>;
}

export const isBoundMetrics = isType<BoundMetrics>(Type.BoundMetrics);


export interface Line {
  _type: Type.Line;

}

export const isLine = isType<Line>(Type.Line);


export interface ComponentHighlightLocation {
  _type: Type.ComponentHighlightLocation;
  section: string;
  weight?: number;
}

export const isComponentHighlightLocation = isType<ComponentHighlightLocation>(Type.ComponentHighlightLocation);


export interface ComponentSummaryLocation {
  _type: Type.ComponentSummaryLocation;
  weight?: number;
}

export const isComponentSummaryLocation = isType<ComponentSummaryLocation>(Type.ComponentSummaryLocation);


export interface MetricBinding {
  _type: Type.MetricBinding;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  queries: Array<MetricBindingQuery>;
  scope: string;
  unit?: string;
  chartType: ChartType;
  priority: TelemetryStreamPriority;
  valuation?: MetricValuation;
  tags?: Record<string, string>;
  enabled: boolean;
  layout?: MetricBindingLayout;
  onlyForEdition?: OnlyForEdition;
}

export const isMetricBinding = isType<MetricBinding>(Type.MetricBinding);


export interface MetricBindingLayout {
  _type: Type.MetricBindingLayout;
  metricPerspective?: MetricPerspectiveLocation;
  componentHighlight?: ComponentHighlightLocation;
  componentSummary?: ComponentSummaryLocation;
}

export const isMetricBindingLayout = isType<MetricBindingLayout>(Type.MetricBindingLayout);


export interface MetricBindingQuery {
  _type: Type.MetricBindingQuery;
  expression: string;
  alias: string;
  componentIdentifierTemplate?: string;
  primary?: boolean;
}

export const isMetricBindingQuery = isType<MetricBindingQuery>(Type.MetricBindingQuery);


export interface MetricPerspectiveLocation {
  _type: Type.MetricPerspectiveLocation;
  tab: string;
  section: string;
  weight?: number;
}

export const isMetricPerspectiveLocation = isType<MetricPerspectiveLocation>(Type.MetricPerspectiveLocation);


export interface HigherIsBetter {
  _type: Type.HigherIsBetter;

}

export const isHigherIsBetter = isType<HigherIsBetter>(Type.HigherIsBetter);


export interface LowerIsBetter {
  _type: Type.LowerIsBetter;

}

export const isLowerIsBetter = isType<LowerIsBetter>(Type.LowerIsBetter);


export interface SpanFilter {
  _type: Type.SpanFilter;
  serviceName?: Array<string>;
  spanName?: Array<string>;
  attributes?: Record<string, Array<string>>;
  spanKind?: Array<SpanKind>;
  durationFromNanos?: number;
  durationToNanos?: number;
  statusCode?: Array<SpanStatusCode>;
  spanParentType?: Array<SpanParentType>;
  traceId?: Array<string>;
  spanId?: Array<string>;
  scopeName?: Array<string>;
  scopeVersion?: Array<string>;
}

export const isSpanFilter = isType<SpanFilter>(Type.SpanFilter);


export interface SpanToComponentBinding {
  _type: Type.SpanToComponentBinding;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  urnTemplate: string;
}

export const isSpanToComponentBinding = isType<SpanToComponentBinding>(Type.SpanToComponentBinding);


export interface High {
  _type: Type.High;

}

export const isHigh = isType<High>(Type.High);


export interface Low {
  _type: Type.Low;

}

export const isLow = isType<Low>(Type.Low);


export interface Medium {
  _type: Type.Medium;

}

export const isMedium = isType<Medium>(Type.Medium);


export interface None {
  _type: Type.None;

}

export const isNone = isType<None>(Type.None);


export interface TraceBinding {
  _type: Type.TraceBinding;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  filter: SpanFilter;
  scope: string;
  urnTemplate?: string;
}

export const isTraceBinding = isType<TraceBinding>(Type.TraceBinding);

export enum ChartType {
  Line = "line",
}

export enum MetricValuation {
  HigherIsBetter = "higher-is-better",
  LowerIsBetter = "lower-is-better",
}


export interface Point {
  _type: Type.Point;
  timestamp: number;
  value: number;
}

export const isPoint = isType<Point>(Type.Point);

export enum TelemetryStreamPriority {
  None = "none",
  Low = "low",
  Medium = "medium",
  High = "high",
}


export interface TimeSeries {
  _type: Type.TimeSeries;
  id: TimeSeriesId;
  points: Array<Point>;
  tags?: Array<string>;
}

export const isTimeSeries = isType<TimeSeries>(Type.TimeSeries);


export interface TimeSeriesId {
  _type: Type.TimeSeriesId;
  elementId?: NodeId;
  groups: Record<string, string>;
}

export const isTimeSeriesId = isType<TimeSeriesId>(Type.TimeSeriesId);


export interface Subscription {
  _type: Type.Subscription;
  tenant: string;
  expiryTimestampMs?: number;
  plan: string;
}

export const isSubscription = isType<Subscription>(Type.Subscription);


export type SubscriptionState = ExpiredSubscription | LicensedSubscription | UnlicensedSubscription;

export function isSubscriptionState(input: unknown): input is SubscriptionState {
  return isExpiredSubscription(input) || isLicensedSubscription(input) || isUnlicensedSubscription(input);
}


export interface ExpiredSubscription {
  _type: Type.ExpiredSubscription;
  subscription: Subscription;
}

export const isExpiredSubscription = isType<ExpiredSubscription>(Type.ExpiredSubscription);


export interface LicensedSubscription {
  _type: Type.LicensedSubscription;
  subscription: Subscription;
}

export const isLicensedSubscription = isType<LicensedSubscription>(Type.LicensedSubscription);

export enum UnlicensedReason {
  Missing = "missing",
  Invalid = "invalid",
}


export interface Invalid {
  _type: Type.Invalid;

}

export const isInvalid = isType<Invalid>(Type.Invalid);


export interface Missing {
  _type: Type.Missing;

}

export const isMissing = isType<Missing>(Type.Missing);


export interface UnlicensedSubscription {
  _type: Type.UnlicensedSubscription;
  reason: UnlicensedReason;
}

export const isUnlicensedSubscription = isType<UnlicensedSubscription>(Type.UnlicensedSubscription);


export interface LicenseKey {
  _type: Type.LicenseKey;
  key: string;
}

export const isLicenseKey = isType<LicenseKey>(Type.LicenseKey);


export interface ServiceToken {
  _type: Type.ServiceToken;
  name: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  fingerprint: string;
  expiration?: number;
  roles: Array<string>;
  dedicatedSubject?: string;
}

export const isServiceToken = isType<ServiceToken>(Type.ServiceToken);


export interface ApiToken {
  _type: Type.ApiToken;
  name: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  token: string;
  userProfile?: NodeId;
}

export const isApiToken = isType<ApiToken>(Type.ApiToken);


export interface UserProfile {
  _type: Type.UserProfile;
  name: string;
  identifier?: string;
  ownedBy?: string;
  optionalName?: string;
  description?: string;
  id?: NodeId;
  lastUpdateTimestamp?: number;
  displayName?: string;
  starredViews?: Array<NodeId>;
  starredDashboards?: Array<NodeId>;
  systemNotificationsRead?: Array<string>;
  hideUnavailableMonitors: boolean;
  hideUnavailableMetrics: boolean;
  hideUnavailableConnections: boolean;
}

export const isUserProfile = isType<UserProfile>(Type.UserProfile);


export interface LabelPrefixedFilter {
  _type: Type.LabelPrefixedFilter;
  prefix: string;
  name: string;
}

export const isLabelPrefixedFilter = isType<LabelPrefixedFilter>(Type.LabelPrefixedFilter);


export interface TopologyFilters {
  _type: Type.TopologyFilters;
  tabs: Array<TopologyFilterValue>;
}

export const isTopologyFilters = isType<TopologyFilters>(Type.TopologyFilters);


export type ViewTypeFilter = LabelPrefixedFilter | TopologyFilters;

export function isViewTypeFilter(input: unknown): input is ViewTypeFilter {
  return isLabelPrefixedFilter(input) || isTopologyFilters(input);
}


export interface ViewTypeOverview {
  _type: Type.ViewTypeOverview;
  columns: Array<ViewTypeTableCol>;
}

export const isViewTypeOverview = isType<ViewTypeOverview>(Type.ViewTypeOverview);


export type ViewTypeTableCol = ViewTypeTableColComponentLink | ViewTypeTableColComponentType | ViewTypeTableColContainerImageLink | ViewTypeTableColDuration | ViewTypeTableColHealth | ViewTypeTableColMetricBinding | ViewTypeTableColName | ViewTypeTableColNumber | ViewTypeTableColPromQL | ViewTypeTableColRatio | ViewTypeTableColReadyStatus | ViewTypeTableColText | ViewTypeTableColTime;

export function isViewTypeTableCol(input: unknown): input is ViewTypeTableCol {
  return isViewTypeTableColComponentLink(input) || isViewTypeTableColComponentType(input) || isViewTypeTableColContainerImageLink(input) || isViewTypeTableColDuration(input) || isViewTypeTableColHealth(input) || isViewTypeTableColMetricBinding(input) || isViewTypeTableColName(input) || isViewTypeTableColNumber(input) || isViewTypeTableColPromQL(input) || isViewTypeTableColRatio(input) || isViewTypeTableColReadyStatus(input) || isViewTypeTableColText(input) || isViewTypeTableColTime(input);
}


export interface ViewTypeTableColComponentLink {
  _type: Type.ViewTypeTableColComponentLink;
  title: string;
  labelPrefix: string;
  pathToIdentifier: Array<string>;
  width?: number;
}

export const isViewTypeTableColComponentLink = isType<ViewTypeTableColComponentLink>(Type.ViewTypeTableColComponentLink);


export interface ViewTypeTableColComponentType {
  _type: Type.ViewTypeTableColComponentType;
  title: string;
  width?: number;
}

export const isViewTypeTableColComponentType = isType<ViewTypeTableColComponentType>(Type.ViewTypeTableColComponentType);


export interface ViewTypeTableColContainerImageLink {
  _type: Type.ViewTypeTableColContainerImageLink;
  title: string;
  imageIdPath: Array<string>;
  imagePath: Array<string>;
  width?: number;
}

export const isViewTypeTableColContainerImageLink = isType<ViewTypeTableColContainerImageLink>(Type.ViewTypeTableColContainerImageLink);


export interface ViewTypeTableColDuration {
  _type: Type.ViewTypeTableColDuration;
  title: string;
  path: Array<string>;
  endDatePath?: Array<string>;
}

export const isViewTypeTableColDuration = isType<ViewTypeTableColDuration>(Type.ViewTypeTableColDuration);


export interface ViewTypeTableColHealth {
  _type: Type.ViewTypeTableColHealth;

}

export const isViewTypeTableColHealth = isType<ViewTypeTableColHealth>(Type.ViewTypeTableColHealth);


export interface ViewTypeTableColMetricBinding {
  _type: Type.ViewTypeTableColMetricBinding;
  title: string;
  metricBindingIdentifier: string;
  width?: number;
  onlyTrendLine: boolean;
}

export const isViewTypeTableColMetricBinding = isType<ViewTypeTableColMetricBinding>(Type.ViewTypeTableColMetricBinding);


export interface ViewTypeTableColName {
  _type: Type.ViewTypeTableColName;
  title: string;
}

export const isViewTypeTableColName = isType<ViewTypeTableColName>(Type.ViewTypeTableColName);


export interface ViewTypeTableColNumber {
  _type: Type.ViewTypeTableColNumber;
  title: string;
  path: Array<string>;
  width?: number;
  unit?: string;
}

export const isViewTypeTableColNumber = isType<ViewTypeTableColNumber>(Type.ViewTypeTableColNumber);


export interface ViewTypeTableColPromQL {
  _type: Type.ViewTypeTableColPromQL;
  title: string;
  query: string;
  componentIdentifierTemplate: string;
  unit?: string;
  width?: number;
}

export const isViewTypeTableColPromQL = isType<ViewTypeTableColPromQL>(Type.ViewTypeTableColPromQL);


export interface ViewTypeTableColRatio {
  _type: Type.ViewTypeTableColRatio;
  title: string;
  numeratorPath: Array<string>;
  denominatorPath: Array<string>;
}

export const isViewTypeTableColRatio = isType<ViewTypeTableColRatio>(Type.ViewTypeTableColRatio);


export interface ViewTypeTableColReadyStatus {
  _type: Type.ViewTypeTableColReadyStatus;
  title: string;
  readyPath: Array<string>;
  totalPath: Array<string>;
  statusPath: Array<string>;
}

export const isViewTypeTableColReadyStatus = isType<ViewTypeTableColReadyStatus>(Type.ViewTypeTableColReadyStatus);


export interface ViewTypeTableColText {
  _type: Type.ViewTypeTableColText;
  title: string;
  path: Array<string>;
  width?: number;
  align?: string;
}

export const isViewTypeTableColText = isType<ViewTypeTableColText>(Type.ViewTypeTableColText);


export interface ViewTypeTableColTime {
  _type: Type.ViewTypeTableColTime;
  title: string;
  path: Array<string>;
}

export const isViewTypeTableColTime = isType<ViewTypeTableColTime>(Type.ViewTypeTableColTime);


export type NoSaas = DeleteStackpacks | ExecuteRestrictedScripts | ExecuteScripts | GetSettings | GetTopicMessages | UnlockSettings | UpdateSettings | UpdateStackpacks;

export function isNoSaas(input: unknown): input is NoSaas {
  return isDeleteStackpacks(input) || isExecuteRestrictedScripts(input) || isExecuteScripts(input) || isGetSettings(input) || isGetTopicMessages(input) || isUnlockSettings(input) || isUpdateSettings(input) || isUpdateStackpacks(input);
}

export enum Permission {
  GetAgents = "get-agents",
  GetApiTokens = "get-api-tokens",
  ExecuteComponentActions = "execute-component-actions",
  GetMetricBindings = "get-metric-bindings",
  CreateMetricBindings = "create-metric-bindings",
  UpdateMetricBindings = "update-metric-bindings",
  DeleteMetricBindings = "delete-metric-bindings",
  GetMetrics = "get-metrics",
  UpdateMetrics = "update-metrics",
  GetMonitors = "get-monitors",
  CreateMonitors = "create-monitors",
  UpdateMonitors = "update-monitors",
  DeleteMonitors = "delete-monitors",
  ExecuteMonitors = "execute-monitors",
  GetNotifications = "get-notifications",
  CreateNotifications = "create-notifications",
  UpdateNotifications = "update-notifications",
  DeleteNotifications = "delete-notifications",
  GetPermissions = "get-permissions",
  UpdatePermissions = "update-permissions",
  UpdateScopedPermissions = "update-scoped-permissions",
  ExecuteScripts = "execute-scripts",
  ExecuteRestrictedScripts = "execute-restricted-scripts",
  GetServiceTokens = "get-service-tokens",
  CreateServiceTokens = "create-service-tokens",
  DeleteServiceTokens = "delete-service-tokens",
  GetSettings = "get-settings",
  UpdateSettings = "update-settings",
  UnlockSettings = "unlock-settings",
  GetStackpacks = "get-stackpacks",
  UpdateStackpacks = "update-stackpacks",
  DeleteStackpacks = "delete-stackpacks",
  CreateStackpackConfigurations = "create-stackpack-configurations",
  UpdateStackpackConfigurations = "update-stackpack-configurations",
  DeleteStackpackConfigurations = "delete-stackpack-configurations",
  GetSyncData = "get-sync-data",
  DeleteSyncData = "delete-sync-data",
  GetSystemNotifications = "get-system-notifications",
  GetTopicMessages = "get-topic-messages",
  GetTopology = "get-topology",
  GetTraces = "get-traces",
  GetViews = "get-views",
  CreateViews = "create-views",
  UpdateViews = "update-views",
  DeleteViews = "delete-views",
  CreateFavoriteViews = "create-favorite-views",
  DeleteFavoriteViews = "delete-favorite-views",
  UpdateVisualization = "update-visualization",
  GetDashboards = "get-dashboards",
  CreateDashboards = "create-dashboards",
  UpdateDashboards = "update-dashboards",
  DeleteDashboards = "delete-dashboards",
  CreateFavoriteDashboards = "create-favorite-dashboards",
  DeleteFavoriteDashboards = "delete-favorite-dashboards",
  GetOtelMappings = "get-otel-mappings",
  CreateOtelMappings = "create-otel-mappings",
  UpdateOtelMappings = "update-otel-mappings",
  DeleteOtelMappings = "delete-otel-mappings",
  GetComponentPresentations = "get-component-presentations",
  CreateComponentPresentations = "create-component-presentations",
  UpdateComponentPresentations = "update-component-presentations",
  DeleteComponentPresentations = "delete-component-presentations",
  ExecuteAi = "execute-ai",
}


export interface CreateComponentPresentations {
  _type: Type.CreateComponentPresentations;

}

export const isCreateComponentPresentations = isType<CreateComponentPresentations>(Type.CreateComponentPresentations);


export interface CreateDashboards {
  _type: Type.CreateDashboards;

}

export const isCreateDashboards = isType<CreateDashboards>(Type.CreateDashboards);


export interface CreateFavoriteDashboards {
  _type: Type.CreateFavoriteDashboards;

}

export const isCreateFavoriteDashboards = isType<CreateFavoriteDashboards>(Type.CreateFavoriteDashboards);


export interface CreateFavoriteViews {
  _type: Type.CreateFavoriteViews;

}

export const isCreateFavoriteViews = isType<CreateFavoriteViews>(Type.CreateFavoriteViews);


export interface CreateMetricBindings {
  _type: Type.CreateMetricBindings;

}

export const isCreateMetricBindings = isType<CreateMetricBindings>(Type.CreateMetricBindings);


export interface CreateMonitors {
  _type: Type.CreateMonitors;

}

export const isCreateMonitors = isType<CreateMonitors>(Type.CreateMonitors);


export interface CreateNotifications {
  _type: Type.CreateNotifications;

}

export const isCreateNotifications = isType<CreateNotifications>(Type.CreateNotifications);


export interface CreateOtelMappings {
  _type: Type.CreateOtelMappings;

}

export const isCreateOtelMappings = isType<CreateOtelMappings>(Type.CreateOtelMappings);


export interface CreateServiceTokens {
  _type: Type.CreateServiceTokens;

}

export const isCreateServiceTokens = isType<CreateServiceTokens>(Type.CreateServiceTokens);


export interface CreateStackpackConfigurations {
  _type: Type.CreateStackpackConfigurations;

}

export const isCreateStackpackConfigurations = isType<CreateStackpackConfigurations>(Type.CreateStackpackConfigurations);


export interface CreateViews {
  _type: Type.CreateViews;

}

export const isCreateViews = isType<CreateViews>(Type.CreateViews);


export interface DeleteComponentPresentations {
  _type: Type.DeleteComponentPresentations;

}

export const isDeleteComponentPresentations = isType<DeleteComponentPresentations>(Type.DeleteComponentPresentations);


export interface DeleteDashboards {
  _type: Type.DeleteDashboards;

}

export const isDeleteDashboards = isType<DeleteDashboards>(Type.DeleteDashboards);


export interface DeleteFavoriteDashboards {
  _type: Type.DeleteFavoriteDashboards;

}

export const isDeleteFavoriteDashboards = isType<DeleteFavoriteDashboards>(Type.DeleteFavoriteDashboards);


export interface DeleteFavoriteViews {
  _type: Type.DeleteFavoriteViews;

}

export const isDeleteFavoriteViews = isType<DeleteFavoriteViews>(Type.DeleteFavoriteViews);


export interface DeleteMetricBindings {
  _type: Type.DeleteMetricBindings;

}

export const isDeleteMetricBindings = isType<DeleteMetricBindings>(Type.DeleteMetricBindings);


export interface DeleteMonitors {
  _type: Type.DeleteMonitors;

}

export const isDeleteMonitors = isType<DeleteMonitors>(Type.DeleteMonitors);


export interface DeleteNotifications {
  _type: Type.DeleteNotifications;

}

export const isDeleteNotifications = isType<DeleteNotifications>(Type.DeleteNotifications);


export interface DeleteOtelMappings {
  _type: Type.DeleteOtelMappings;

}

export const isDeleteOtelMappings = isType<DeleteOtelMappings>(Type.DeleteOtelMappings);


export interface DeleteServiceTokens {
  _type: Type.DeleteServiceTokens;

}

export const isDeleteServiceTokens = isType<DeleteServiceTokens>(Type.DeleteServiceTokens);


export interface DeleteStackpackConfigurations {
  _type: Type.DeleteStackpackConfigurations;

}

export const isDeleteStackpackConfigurations = isType<DeleteStackpackConfigurations>(Type.DeleteStackpackConfigurations);


export interface DeleteStackpacks {
  _type: Type.DeleteStackpacks;

}

export const isDeleteStackpacks = isType<DeleteStackpacks>(Type.DeleteStackpacks);


export interface DeleteSyncData {
  _type: Type.DeleteSyncData;

}

export const isDeleteSyncData = isType<DeleteSyncData>(Type.DeleteSyncData);


export interface DeleteViews {
  _type: Type.DeleteViews;

}

export const isDeleteViews = isType<DeleteViews>(Type.DeleteViews);


export interface ExecuteAi {
  _type: Type.ExecuteAi;

}

export const isExecuteAi = isType<ExecuteAi>(Type.ExecuteAi);


export interface ExecuteComponentActions {
  _type: Type.ExecuteComponentActions;

}

export const isExecuteComponentActions = isType<ExecuteComponentActions>(Type.ExecuteComponentActions);


export interface ExecuteMonitors {
  _type: Type.ExecuteMonitors;

}

export const isExecuteMonitors = isType<ExecuteMonitors>(Type.ExecuteMonitors);


export interface ExecuteRestrictedScripts {
  _type: Type.ExecuteRestrictedScripts;

}

export const isExecuteRestrictedScripts = isType<ExecuteRestrictedScripts>(Type.ExecuteRestrictedScripts);


export interface ExecuteScripts {
  _type: Type.ExecuteScripts;

}

export const isExecuteScripts = isType<ExecuteScripts>(Type.ExecuteScripts);


export interface GetAgents {
  _type: Type.GetAgents;

}

export const isGetAgents = isType<GetAgents>(Type.GetAgents);


export interface GetApiTokens {
  _type: Type.GetApiTokens;

}

export const isGetApiTokens = isType<GetApiTokens>(Type.GetApiTokens);


export interface GetComponentPresentations {
  _type: Type.GetComponentPresentations;

}

export const isGetComponentPresentations = isType<GetComponentPresentations>(Type.GetComponentPresentations);


export interface GetDashboards {
  _type: Type.GetDashboards;

}

export const isGetDashboards = isType<GetDashboards>(Type.GetDashboards);


export interface GetMetricBindings {
  _type: Type.GetMetricBindings;

}

export const isGetMetricBindings = isType<GetMetricBindings>(Type.GetMetricBindings);


export interface GetMetrics {
  _type: Type.GetMetrics;

}

export const isGetMetrics = isType<GetMetrics>(Type.GetMetrics);


export interface GetMonitors {
  _type: Type.GetMonitors;

}

export const isGetMonitors = isType<GetMonitors>(Type.GetMonitors);


export interface GetNotifications {
  _type: Type.GetNotifications;

}

export const isGetNotifications = isType<GetNotifications>(Type.GetNotifications);


export interface GetOtelMappings {
  _type: Type.GetOtelMappings;

}

export const isGetOtelMappings = isType<GetOtelMappings>(Type.GetOtelMappings);


export interface GetPermissions {
  _type: Type.GetPermissions;

}

export const isGetPermissions = isType<GetPermissions>(Type.GetPermissions);


export interface GetServiceTokens {
  _type: Type.GetServiceTokens;

}

export const isGetServiceTokens = isType<GetServiceTokens>(Type.GetServiceTokens);


export interface GetSettings {
  _type: Type.GetSettings;

}

export const isGetSettings = isType<GetSettings>(Type.GetSettings);


export interface GetStackpacks {
  _type: Type.GetStackpacks;

}

export const isGetStackpacks = isType<GetStackpacks>(Type.GetStackpacks);


export interface GetSyncData {
  _type: Type.GetSyncData;

}

export const isGetSyncData = isType<GetSyncData>(Type.GetSyncData);


export interface GetSystemNotifications {
  _type: Type.GetSystemNotifications;

}

export const isGetSystemNotifications = isType<GetSystemNotifications>(Type.GetSystemNotifications);


export interface GetTopicMessages {
  _type: Type.GetTopicMessages;

}

export const isGetTopicMessages = isType<GetTopicMessages>(Type.GetTopicMessages);


export interface GetTopology {
  _type: Type.GetTopology;

}

export const isGetTopology = isType<GetTopology>(Type.GetTopology);


export interface GetTraces {
  _type: Type.GetTraces;

}

export const isGetTraces = isType<GetTraces>(Type.GetTraces);


export interface GetViews {
  _type: Type.GetViews;

}

export const isGetViews = isType<GetViews>(Type.GetViews);


export interface UnlockSettings {
  _type: Type.UnlockSettings;

}

export const isUnlockSettings = isType<UnlockSettings>(Type.UnlockSettings);


export interface UpdateComponentPresentations {
  _type: Type.UpdateComponentPresentations;

}

export const isUpdateComponentPresentations = isType<UpdateComponentPresentations>(Type.UpdateComponentPresentations);


export interface UpdateDashboards {
  _type: Type.UpdateDashboards;

}

export const isUpdateDashboards = isType<UpdateDashboards>(Type.UpdateDashboards);


export interface UpdateMetricBindings {
  _type: Type.UpdateMetricBindings;

}

export const isUpdateMetricBindings = isType<UpdateMetricBindings>(Type.UpdateMetricBindings);


export interface UpdateMetrics {
  _type: Type.UpdateMetrics;

}

export const isUpdateMetrics = isType<UpdateMetrics>(Type.UpdateMetrics);


export interface UpdateMonitors {
  _type: Type.UpdateMonitors;

}

export const isUpdateMonitors = isType<UpdateMonitors>(Type.UpdateMonitors);


export interface UpdateNotifications {
  _type: Type.UpdateNotifications;

}

export const isUpdateNotifications = isType<UpdateNotifications>(Type.UpdateNotifications);


export interface UpdateOtelMappings {
  _type: Type.UpdateOtelMappings;

}

export const isUpdateOtelMappings = isType<UpdateOtelMappings>(Type.UpdateOtelMappings);


export interface UpdatePermissions {
  _type: Type.UpdatePermissions;

}

export const isUpdatePermissions = isType<UpdatePermissions>(Type.UpdatePermissions);


export interface UpdateScopedPermissions {
  _type: Type.UpdateScopedPermissions;

}

export const isUpdateScopedPermissions = isType<UpdateScopedPermissions>(Type.UpdateScopedPermissions);


export interface UpdateSettings {
  _type: Type.UpdateSettings;

}

export const isUpdateSettings = isType<UpdateSettings>(Type.UpdateSettings);


export interface UpdateStackpackConfigurations {
  _type: Type.UpdateStackpackConfigurations;

}

export const isUpdateStackpackConfigurations = isType<UpdateStackpackConfigurations>(Type.UpdateStackpackConfigurations);


export interface UpdateStackpacks {
  _type: Type.UpdateStackpacks;

}

export const isUpdateStackpacks = isType<UpdateStackpacks>(Type.UpdateStackpacks);


export interface UpdateViews {
  _type: Type.UpdateViews;

}

export const isUpdateViews = isType<UpdateViews>(Type.UpdateViews);


export interface UpdateVisualization {
  _type: Type.UpdateVisualization;

}

export const isUpdateVisualization = isType<UpdateVisualization>(Type.UpdateVisualization);


export type PermissionStreamRequest = SubjectPermissionsRequest;

export function isPermissionStreamRequest(input: unknown): input is PermissionStreamRequest {
  return isSubjectPermissionsRequest(input);
}


export type ScopedPermission = DeleteViews | GetMetrics | GetTopology | GetTraces | GetViews | UpdateScopedPermissions | UpdateViews;

export function isScopedPermission(input: unknown): input is ScopedPermission {
  return isDeleteViews(input) || isGetMetrics(input) || isGetTopology(input) || isGetTraces(input) || isGetViews(input) || isUpdateScopedPermissions(input) || isUpdateViews(input);
}


export interface SubjectPermissionsRequest {
  _type: Type.SubjectPermissionsRequest;

}

export const isSubjectPermissionsRequest = isType<SubjectPermissionsRequest>(Type.SubjectPermissionsRequest);


export interface SubjectPermissionsResponse {
  _type: Type.SubjectPermissionsResponse;
  subjects: Array<Subject>;
  systemPermissions: Array<Permission>;
  resourcePermissions: Record<string, Array<Permission>>;
}

export const isSubjectPermissionsResponse = isType<SubjectPermissionsResponse>(Type.SubjectPermissionsResponse);

export enum SubjectSource {
  Static = "Static",
  Observability = "Observability",
  Kubernetes = "Kubernetes",
}


export interface ScopeDefinition {
  _type: Type.ScopeDefinition;
  query?: string;
}

export const isScopeDefinition = isType<ScopeDefinition>(Type.ScopeDefinition);


export interface Subject {
  _type: Type.Subject;
  handle: string;
}

export const isSubject = isType<Subject>(Type.Subject);


export interface SubjectPermissions {
  _type: Type.SubjectPermissions;
  subjectHandle: string;
  fromSources: Array<SubjectSource>;
  permissions: Record<string, Array<Permission>>;
}

export const isSubjectPermissions = isType<SubjectPermissions>(Type.SubjectPermissions);


export interface SubjectWithSource {
  _type: Type.SubjectWithSource;
  handle: string;
  source: SubjectSource;
}

export const isSubjectWithSource = isType<SubjectWithSource>(Type.SubjectWithSource);

export enum HealthState {
  Starting = "STARTING",
  Okay = "OKAY",
  Failing = "FAILING",
  Initializing = "INITIALIZING",
  Clearing = "CLEARING",
  Stopping = "STOPPING",
  UnableToDetermine = "UNABLE_TO_DETERMINE",
  Stopped = "STOPPED",
}

export enum StackPackAction {
  Upgrade = "UPGRADE",
  Install = "INSTALL",
  Uninstall = "UNINSTALL",
}

export enum StackPackInstanceState {
  Provisioning = "PROVISIONING",
  WaitingForData = "WAITING_FOR_DATA",
  Installed = "INSTALLED",
  Upgrading = "UPGRADING",
  Deprovisioning = "DEPROVISIONING",
  NotInstalled = "NOT_INSTALLED",
  Error = "ERROR",
  WaitingForManualSteps = "WAITING_FOR_MANUAL_STEPS",
}

export enum StackPackStatus {
  Available = "AVAILABLE",
  Enabled = "ENABLED",
  ComingSoon = "COMING_SOON",
  Hidden = "HIDDEN",
  Broken = "BROKEN",
}


// end of generated interface
